export const LANG_KO_NAME = 'ko';

export const LANG_KO_TRANS = {
    "AUDIT_UserDeviceService_extCode": "확장코드",
    "MdmPolicyControlName_WLANScanMode": "WLAN 스캔모드",
    "LANG_loadRemoteConrolPage": "단말기 원격제어 페이지로 이동하시겠습니까?",
    "LANG_SETTING_OrganManagementDetail": "MDM사용자의 조직 및 부서를 관리합니다.",
    "Hash": "해쉬값",
    "MdmPolicyControlName_safariForceFraudWarning": "위조 경고 강제",
    "MdmPolicyControlName_encInMemory": "내장 메모리 암호화",
    "LANG_policyPublishToSave": "정책 적용",
    "AUDIT_UserDeviceService_updateDate": "갱신시간",
    "AUDIT_ControlAPService_updateDate": "갱신시간",
    "RC_GET_SYSTEM_INFO": "시스템 정보 조회",
    "AUDIT_ControlAPService_createDate": "생성시간",
    "LANG_ALT_addUser": "MDM 사용자를 추가합니다",
    "LANG_LOG_DeviceLog": "단말로그",
    "LANG_REMOTE_BACKUP_EXPLANATION": "단말기의 주요정보를 서버에 저장 할수 있습니다. 새로고침 버튼을 누르시면 최종 백업 및 복구 정보를 보실 수 있습니다.",
    "LANG_AP_ADD": "AP(Access Point) 추가",
    "ACTION_DeviceService_sync": "단말 동기화 통신",
    "RC_POLICY_OFF": "단말정책 일시해제 (Android)",
    "BLACKAPPDEL": "삭제",
    "LANG_modifyBlackApp": "블랙앱 수정",
    "LANG_thus": "목",
    "IsUseFlag_Use": "USE",
    "MdmPolicyControlName_screenLockPattern": "화면 잠금 패턴",
    "MdmPolicyControlName_AllowStore": "스토어 허용.",
    "CertTerminated": "폐기여부",
    "LANG_APP_OldVersion": "이전버전",
    "MdmPolicyControlName_allowOSUpdate": "OS업데이트 허용",
    "MdmPolicyControlName_AllowMultiUser": "멀티유저 허용",
    "MdmPolicyControlName_AllowFactoryReset": "공장초기화 허용",
    "ERROR_unauthorized_phoneNumber": "승인 되지 않은 전화번호입니다.",
    "Title_000000001": "시스템관리자",
    "Password": "패스워드",
    "ERROR_UserSessionTimeout": "관리자 세션 타임아웃으로 로그아웃 되었습니다.",
    "targetName": "대상 이름",
    "AUDIT_LocationService_name": "명칭",
    "MdmPolicyControlName_sendPeriodNormalLog": "일반 로그 전송 주기",
    "MdmPolicyControlName_AllowVPNOverCellular": "셀룰러 상에서 VPN허용.",
    "AUDIT_VisitorUserService_companyName": "회사이름",
    "MESSAGE_ALERT_NOT_SELECT_TARGET": "{0} 대상이 선택되지 않았습니다.",
    "LANG_DeviceAppMng": "단말 APP 관리",
    "AUDIT_AppService_packageName": "패키지명",
    "LANG_INITPW_ITEM_NEXT_TIME": "다음에 변경",
    "LANG_Date": "날짜",
    "LANG_DEVICE_DeviceTypeManagementDetail": "단말의 모델, OS 등 단말에 대한 기본 정보를 관리합니다.",
    "LANG_ReservedVisitorManagementList_VisitorDepartment": "방문부서",
    "Configuration_securityEnabled": "로그인 보안 제약 적용 여부",
    "LANG_APP_WhiteApp": "화이트앱관리",
    "NotAfter": "유효기간 종료일",
    "MdmPolicyControlName_AllowBrowser": "시스템 브라우져 허용.",
    "LANG_group": "그룹",
    "AL_agentLock": "화면 잠금 수행",
    "LANG_DeviceType": "단말유형",
    "LANG_SecurityIssueManageMent": "보안 이슈 관리",
    "AUDIT_Pkcs12CertificateService_id": "ID",
    "NoticeSubject": "공지제목",
    "ISSUE_SOLVE_ERROR_UserLocked": "사용자가 지정된 암호 실패횟수를 초과하여 잠금 상태가 되었습니다. 잠금을 푸실려면 \"설정\"->\"사용자 관리\" 에서 \"잠금해제\" 를 하십시오.",
    "CONFIRM_TO_Delete": "삭제할 부서는 단일로 선택되어야 합니다.",
    "MdmPolicyControlName_automaticLockScreenTime": "화면 자동 잠금 시간",
    "DeviceCondition": "단말 종합 현황",
    "MESSAGE_ALERT_CONFIRM_INSERT": "추가하시겠습니까?",
    "LANG_DEVICE_unlockToken": "잠금해제 비밀번호",
    "LANG_deviceTypeDetail": "단말유형 상세보기",
    "MdmPolicyControlName_allowAirDrop": "AirDrop 사용 허용",
    "APName": "AP명",
    "LANG_ValidateLogin": "아이디와 패스워드는 필수요소 입니다.",
    "LANG_POLICY_callBlockingOff": "외부 전화걸기 차단 해제 (Android)",
    "TargetCommand": "삭제",
    "MdmPolicyControlName_forceEncryptedBackup": "강제 암호화 백업",
    "Operation_DELETE": "삭제 완료",
    "MdmPolicyControlName_allowExplicitContent": "응용 프로그램 내 구매 허용",
    "ISSUE_SOLVE_GUIDE_DeviceManagerDisabled": "기기를 안전하게 사용하기 위해서 관리자가 기기관리자 활성을 요청하였습니다. 아래와 같이 하여 기기관리자를 활성해 주십시오. 단말의 \"시스템 설정\"->\"보안\"->\"기기 관리자\" 를 선택하면, 보이는 앱 목록에서 \"ExafeMDM\" 을 체크해주십시오.",
    "Audit_ControlAPService": "정책관리>정책자원관리>무선AP관리",
    "Title_Director": "이사",
    "Status_FIXED": "해결",
    "ISSUE_SOLVE_DeviceRooting": "사용자의 단말이 루팅되었습니다. 보안을 위해 해당 단말에서 데이터를 외부로 유출하지 못하도록 차단 하시겠습니까?",
    "jqGrid_search": "검색",
    "MdmPolicyControlName_MaxDevicePasswordFailedAttempts": "비밀번호 최대 실패 횟수.",
    "LANG_PolicyName": "정책명",
    "AUDIT_VersionedAppService_installedApp": "인스톨여부",
    "AUDIT_VersionedAppService_virusResult": "바이러스체크",
    "LANG_count": "개수",
    "LANG_LostStatusTime": "도난분실시간",
    "AUDIT_VersionedAppService_officeApp": "오피스앱여부",
    "LANG_SMS": "SMS전송",
    "ACTION_SystemLockedRemote": "관리자에 의한 시스템 잠김",
    "MdmPolicyControlName_allowMultipleUsers": "다중사용자(Guest) 허용",
    "LANG_policyTargetTitle": "정책 적용 대상",
    "AUDIT_HolidaysService_createDate": "생성시간",
    "LANG_LastSyncTime": "정책 업데이트 일시",
    "LANG_Consent_Person_info": "개인정보 동의여부",
    "MdmPolicyControlName_AllowCellularDataRoaming": "셀룰러 데이터 허용. ",
    "LANG_WP_federated_enrollment_ERROR_exception": "시스템 오류입니다. 시스템 관리자에게 문의하여 주세요.",
    "LANG_TOP_PersonnelManagement": "인사관리",
    "MINUTE05": "5분",
    "Configuration_sessionMaxInactiveInterval_ALERT": "{0} : 300 ~ 1800 사이입니다.",
    "AUDIT_VersionedAppService_packageName": "패키지명",
    "UserName": "사용자 아이디",
    "MINUTE02": "2분",
    "MINUTE01": "1분",
    "AUDIT_UserService_updateDate": "갱신시간",
    "MESSAGE_ALERT_DEFAULT_POLICY_NOT_DELETE": "기본 조건은 삭제 할 수 없습니다.",
    "LostTelNumber": "전화번호",
    "MdmPolicyControlName_sendLogLevel": "로그 전송 레벨",
    "EditAccessPoint": "무선AP변경",
    "AllowedIP_Desc1": "허용된 IP 이외에는 서버에 로그인할 수 없습니다.",
    "LANG_POLICY_listConfigDetail": "MDM정책이 실행될때, 제어할 단말의 기능을 선택합니다.",
    "AllowedIP_Desc2": "필수 한개, 최대 두 개까지 입력할 수 있습니다.",
    "MdmPolicyControlName_removalPassword": "프로파일 제거암호",
    "sourceTypeTargetName": "로그소스명",
    "LANG_INITPW_CONFIRM_PASSWORD": "비밀번호가 변경되었습니다. 다시 로그인하여 주십시오.",
    "AUDIT_VisitorUserService_visitorType": "방문자타입",
    "AUDIT_ControlAPService_ssID": "ssID",
    "AL_agentStop": "MDM 종료",
    "LANG_POLICY_CONDITION_POPUP": "(팝업)",
    "AUDIT_UserTitleService_updateDate": "갱신시간",
    "ERROR_UserStatusIsNotUse": "사용이 중지된 사용자 입니다.",
    "MINUTE10": "10분",
    "deviceCondition_totalInfo": "단말종합정보",
    "LANG_RetainSessionTime": "세션 유지 시간(초)",
    "AUDIT_BeaconAreaService_createDate": "생성시간",
    "LANG_LOGIN_DELETE_ERROR": "관리자 본인 계정은 삭제할 수 없습니다.",
    "LANG_App_Upload_OfficeApp_is_Exists": "업무앱이 존재합니다. ",
    "SAFARIACCEPTCOOKIES_VISITED_SITE": "방문한 사이트만",
    "IsUseFlag_NotUse": "NOT_USE",
    "LANG_MonitoringStatisticsDetail": "MDM 앱을 설치한 방문자 목록 입니다.",
    "LANG_Policy_TargetSave": "정책 적용 대상 저장 성공.",
    "AddSecurityIssue": "보안 이슈 추가",
    "LANG_PhoneNumber": "전화번호",
    "LANG_ManageCertificate": "인증서 관리",
    "deviceCondition_totalInfo_summary": "좌측맵을 클릭하시면 해당정보를 보실 수 있습니다.",
    "LANG_ReservedVisitorManagementRegister": "예약 방문자 등록",
    "LANG_WARNING_LEVEL2_MSG": "WARN Level : 단순한 오류에 대한 로그",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_SCOPE": "시간범위",
    "MdmPolicyControlName_AllowInternetSharing": "인터넷 공유허용.",
    "LANG_ManagerConfig": "관리자 설정",
    "ERROR_DBLimitCritical": "저장소의 허용용량 초과 제한 비율에 도달하였습니다. 저장소 확보에 대한 조치를 하여야 합니다.",
    "AUDIT_VisitorUserService_visitorDeptName": "방문부서이름",
    "LANG_DEVICE_PositionInfomation2": "위치상세정보",
    "MdmPolicyControlName_maxPINAgeInDays": "최대 암호 사용 기간 (일)",
    "AUDIT_VisitorUserService_visitorActionType": "방문 실행 형태",
    "AUDIT_UserService_username": "사용자명",
    "Validation_alert": "[{0}] 은/는 필수 항목입니다.",
    "LANG_SuccessToDeploy": "정책을 저장후에 배포처리 하였습니다.",
    "AUDIT_LocationService_longitude": "경도",
    "LANG_PolicyIn": "IN 정책",
    "ACTION_DeviceInactiveMaximumTime": "단말 통신 미발생",
    "LANG_Line10": "10줄씩 보기",
    "LANG_Company_Not_Found": "회사정보가 존재하지 않습니다.",
    "AUDIT_LocationService_areaCode": "지역코드",
    "Configuration_scepUrl_DESC": "iPhone 프로파일 설치를 위한 인증(CA) 서비스 URL을 설정합니다.",
    "MdmPolicyControlName_typeBrightnessAdjustment": "밝기조정 유형",
    "LANG_Windows_App_Select02": "설정안함.",
    "LANG_Windows_App_Select01": "비 잠금을 허용.",
    "LANG_APP_BusinessAppState": "업무앱 설치현황",
    "LANG_APP_MDMAppState": "에이전트 설치현황",
    "LANG_NOTICE_ListNull": "등록된 공지사항이 없습니다.",
    "MdmPolicyControlName_safariAllowPopups": "팝업 차단",
    "ModifyNotice": "공지 변경",
    "LANG_Windows_App_Select00": "거부.",
    "LANG_LOG_AuditLatest": "최근감사로그",
    "MdmPolicyControlName_forcePIN": "암호정책 사용 여부",
    "PasswordPolicyAlphabet": "영문자",
    "Audit_AppService": "단말기관리>앱관리",
    "TermRefresh": "새로고침",
    "LANG_SETTING_NoticeManagement": "공지관리",
    "MdmPolicyControlName_AllowVPNRoamingOverCellular": "셀룰러 상에서 VPN 로밍 허용.",
    "AUDIT_HolidaysService_id": "ID",
    "LANG_UpdateDate": "갱신일",
    "LANG_DEVICE_AppManagement": "앱 관리",
    "LANG_Line20": "20줄씩 보기",
    "AUDIT_ReservedVisitorService_id": "ID",
    "MdmPolicyControlName_PreventSmartScreenPromptOverride": "잠재적인 웹사이트에 관해 유저가 스마트 스크린을 변경할수 있게 허용.",
    "LANG_DEVICE_detailDevice": "단말기 상세정보 보기",
    "Configuration_encodeDvc_DESC": "앱 위변조를 검증하기 위한 동적 검증 코드의 인코딩 여부를 설정한다.",
    "Configuration_systemEmail_DESC": "보안이슈 발생시 관리자 통지를 위한 이메일을 설정합니다.",
    "LANG_msgAgentInstallState": "사용자가 설치한 MDM APP의 설치현황을 보실 수 있습니다.",
    "LANG_SearchHere": "직접검색",
    "MdmPolicyControlName_AllowScreenCapture": "스크린 캡쳐 허용여부.",
    "LANG_YYYYMMMM": "YYYY년 MMMM",
    "LANG_TargetUser": "사용자",
    "MdmPolicyControlName_AllowCortana": "코타나 허용여부.",
    "AUDIT_ThirdPartyCompanyService_companyType": "업체 명",
    "LANG_Line30": "30줄씩 보기",
    "LANG_YYYYMMMD": "YYYY년 MMM D",
    "LANG_titleDeptName": "직급/부서",
    "selectTargetNoticeManagement": "공지 대상 선택",
    "AUDIT_UserDeviceService_id": "ID",
    "AUDIT_AppService_plistFilePath": "plist파일경로",
    "LANG_jan": "1월",
    "Configuration_adminAccessIPEnabled_DESC": "서버에서 관리하는 접속허용 IP 사용여부를 설정합니다.",
    "PolicyControl_new_category_6003": "Edge 제어",
    "LANG_LostStatusRelease": "도난분실해제",
    "LANG_LOC_addLocation": "위치 추가",
    "PolicyControl_new_category_6000": "Windows OS",
    "WhiteAppAppointment": "화이트리스트 지정",
    "RC_SENT": "명령전송완료",
    "LANG_ReservedVisitorManagementList_VisitorCompetent": "방문담당자",
    "LANG_VALIDATE_SEARCHVALUE_MESSAGE": "검색내용을 입력하십시오.",
    "MdmPolicyControlName_allowGPS": "GPS",
    "LANG_WP_federated_enrollment_item_user_password": "사용자비밀번호",
    "LANG_CompanyBy": "회사명",
    "BUTTON_OK2": "적용",
    "PASSWORD_QUALITY_SOMETHING": "최소잠금",
    "LANG_DEVICE_DeviceRemoteManageDetail": "단말기를 원격제어 할 수 있는 관리페이지입니다.",
    "LANG_Self_Device_location_status": "위치정보 동의여부",
    "LANG_LocationPolicyApplys": "적용",
    "ACTION_ApplicationStarted": "보안시스템 / 감사로그 시작",
    "RC_FOUND": "분실 신고 해제",
    "LANG_ReservedVisitorManagement_KAI_name": "방문객",
    "Status_ACTIVE": "활성",
    "ISSUE_SOLVE_ERROR_DeviceInactiveMaximumTime": "단말이 지정된 시간보다 더 오랫동안 접속한 기록이 없습니다. 대부분의 경우 단말의 전원이 꺼져있을 수 있지만, 접속 통신환경이 나쁜곳에 있거나, 서버와 통신에 문제가 있을 수 있습니다. 단말에 연락을 취해 보안 문제가 되는지 판단하고 적절한 조치를 취해야 합니다.",
    "MdmPolicyControlName_allowiTunes": "iTunes Store 사용 허용",
    "AL_policyAppsApplyFail": "앱 정책 적용 실패",
    "DeviceName": "단말유형",
    "LANG_YYYYMMMD_DAY": "YYYY년 MMM D일",
    "LANG_POLICY_CONDITION": "정책조건",
    "MdmPolicyControlName_MSPASP0000000001": "앱 실행 제어",
    "policyControlList": "현재 선택된 MDM기능 항목",
    "LANG_target2": "대상이",
    "MdmPolicyControlName_MSPASP0000000002": "System Application 제외",
    "MdmPolicyControlName_autoUpdateMdm": "MDM 자동 업그레이드",
    "MdmPolicyControlName_MSPASP0000000003": "Market Application 제외",
    "AUDIT_ControlAPService_pin": "PIN",
    "MdmPolicyControlName_MSPASP0000000004": "MDM 기능 작동 허용",
    "MdmPolicyControlName_MSPASP0000000006": "앱 자동실행 제어(동연S&T 스마트 앱)",
    "MdmPolicyControlName_MSPASP0000000008": "앱 실행 제어옵션",
    "AUDIT_PassingStatusService_": "출입상태 서비스",
    "AUDIT_UserDeviceService_allowedLocationMonitoring": "위치조회허용여부",
    "MdmPolicyControlName_RequireDeviceEncryption": "장치 암호화 필수 허용.",
    "BUTTON_RECOVERY": "복구",
    "LANG_POLICY_listConfig": "정책 항목 설정",
    "RC_OUTCALL_OFF": "전화걸기 차단",
    "MdmPolicyControlName_AntiTheftMode": "AntiTheft 모드허용.",
    "AUDIT_UserDeviceService_unqKey": "고유키",
    "LANG_App_Upload_BlackApp_is_Exists": "차단 앱 이 이미 존재합니다. ",
    "ChangeParentDept": "상위부서변경",
    "AUDIT_UserDeviceService_registered": "등록여부",
    "AUDIT_ThirdPartyCompanyService_ipPattern": "IP패턴",
    "AlertMailBody": "안녕하세요 {0} 님, 앱 {1} 이 다음과 같은 이유로 위변조 검증에 실패하였습니다. 메세지: {2}",
    "LANG_AdminName": "관리자명",
    "AUDIT_ReservedVisitorService_position": "방문자직책",
    "MdmPolicyControlName_minLength": "패스워드 최소길이",
    "BUTTON_APPINFO": "앱정보",
    "AUDIT_HolidaysService_admin": "관리자",
    "MdmPolicyControlName_AllowManualVPNConfiguration": "VPN 설정 메뉴얼 허용.",
    "LANG_Self_Device_remote_device": "단말기 원격제어",
    "LANG_fri": "금",
    "TabBasicInfo": "기본 정보",
    "MdmPolicyControlName_allowCloudBackup": "백업 허용",
    "Audit_HolidaysService": "정책관리>휴일관리",
    "policyConditionAndItemTitle": "정책 조건에 대한 적용 항목",
    "MdmPolicyControlName_AllowTaskSwitcher": "작업 변경 허용.",
    "AddProductDevice": "단말유형 추가",
    "LANG_SETTING_DeviceUserManagement": "사용자관리",
    "LANG_PositionInfomation": "위치정보",
    "LANG_ManageLicense": "라이센스 관리",
    "LANG_EntryPolicyTargetDesc": "출입정책을 적용할  대상(조직별/부서별/사용자별/단말기별)을 선택합니다.",
    "LANG_nov": "11월",
    "LANG_LocationPolicyPresentConditionDetail": "출입정책이 적용된 로그를 확인합니다.",
    "MdmPolicyControlName_MinDevicePasswordComplexCharacters": "최소 비밀번호 문자열 설정.",
    "jqGrid_alertText": "행을 선택해주세요",
    "Configuration_dbmsWarnLimitsize_DESC": "허용용량 경고 제한 비율 설정합니다.(단위 : %, 기본값 : 85, 범위 : 80~90)",
    "Title_000001500": "녹색성장실장",
    "LANG_ERROR_CSRFFilterError": "적절한 토큰으로 접근되지 않아 부적절한 접근으로 인식되어 재시도가 필요합니다.",
    "MdmPolicyControlName_allowPhotoStream": "사진 스트림 허용",
    "ACTION_Login": "관리자 로그인",
    "LANG_LOC_ALERT_addWiFi": "WiFi AP가 없습니다. 먼저 WiFi AP를 추가해야 합니다.",
    "MESSAGE_ALERT_NOT_BETWEEN_VALUE": "{0} 의 범위의 숫자로 입력되어야 합니다.",
    "Title_000001119": "미래기획단장",
    "Title_000001118": "기술연구소장",
    "Title_000001116": "전략경영실장",
    "MdmPolicyControlName_MDMPSP0000000010": "NFC / 안드로이드 무선 송수신 허용",
    "Title_000001117": "전문위원",
    "Title_000001114": "본부장",
    "LANG_REMOTE_CONTROL_LIST": "단말원격제어리스트",
    "Title_000001115": "기술본부장",
    "MdmPolicyControlName_MDMPSP0000000011": "WiFi / 사용  AP 리스트",
    "Title_000001112": "선박안전본부장",
    "Title_000001113": "해사안전연구센터장",
    "Title_000001110": "검사본부장",
    "MdmPolicyControlName_periodLocationUpload": "위치 정보 수집 주기",
    "Title_000001111": "사업본부장",
    "AUDIT_UserService_useVisitor": "방문자사용",
    "PolicyControl_new_category_desc_5000": "Windows Phone 8.1 단말기의 장치 관리를 위한 정책항목을 설정합니다.",
    "MdmPolicyControlName_MDMPSP0000000014": "외장 SDCARD 교체 허용",
    "LANG_ERROR_UserIpNotAllowedUserMessage": "허용되지 않은 IP 로 부터 접근하였습니다.관리자에게 문의하십시오.",
    "MdmPolicyControlName_MDMPSP0000000013": "USIM 교체 허용",
    "AddUser": "사용자 추가",
    "LANG_policyTransferTime": "정책전송시간",
    "Title_000001108": "지원본부장",
    "Title_000001107": "경영지원본부장",
    "LANG_VALIDATE_SEARCHID_MESSAGE": "검색항목을 선택하십시오.",
    "AL_Install_Remove_Log": "앱 설치/삭제 로그",
    "Title_000001109": "안전본부장",
    "Title_000001103": "비상임이사",
    "Title_000001104": "비상임감사",
    "Title_000001105": "감사",
    "Title_000001106": "경영본부장",
    "Title_000001100": "이사장",
    "Title_000001101": "전무이사",
    "Title_000001102": "상임감사",
    "Lang_Policy_HeaderIncluded": "적용여부",
    "LANG_LocationPolicyApplyList": "적용리스트",
    "ActiveUser": "활성",
    "Configuration_adminAccessIPEnabled": "서버 관리 접속허용 IP 사용여부",
    "ACTION_DeviceService_setDeviceHeartBeat2": "단말 하트비트 통신",
    "AUDIT_UserDeviceService_lastPolicyApplied": "최종적용정책",
    "LANG_Today": "오늘",
    "LANG_DEVICE_PositionInfomationDetail": "MDM 사용자의 단말 위치를 조회합니다.",
    "AUDIT_DefenceSettingService_createDate": "생성시간",
    "deviceLostInfo": "도난/분실 정보",
    "LANG_POLICY_conditionConfigDetail": "MDM정책이 실행되는 환경을 설정합니다.",
    "LANG_ExcelExport": "엑셀로 출력",
    "LANG_DEPT_dept": "부서",
    "LANG_PolicyLocationResourceManagement": "출입자원관리",
    "PolicyControl_new_category_5000": "Windows Phone",
    "Title_000001134": "혁신팀장",
    "Title_000001135": "기획홍보팀장",
    "Title_000001132": "기술심사부장",
    "BUTTON_ADD": "추가",
    "Title_000001133": "재정팀장",
    "Title_000001138": "비전기획팀장",
    "Title_000001139": "변화관리자그룹장",
    "Title_000001136": "설계심사팀장",
    "LANG_SETTING_AdminManagement": "관리자관리",
    "LANG_DEVICE_model": "단말모델",
    "AUDIT_ReservedVisitorService_phoneNumber": "전화번호",
    "AUDIT_VersionedAppService_appAgent": "MDM여부",
    "Title_000001137": "사업기획팀장",
    "MESSAGE_ALERT_FAIL_REQUEST": "{0} 요청이 정상적으로 처리 되지 않았습니다.",
    "Title_000001130": "검사제도부장",
    "Title_000001131": "기술사업부장",
    "RC_SET_STATUS": "단말 상태 설정",
    "Title_000001129": "검사관리부장",
    "LANG_Dept_Not_Same": "상위 업체는 자신이 될수 없습니다.",
    "EditConfiguration": "설정 변경",
    "Title_000001121": "기술연구원장",
    "Title_000001122": "단장",
    "Title_000001123": "미래기획부단장",
    "Title_000001124": "경영목표달성을위한T/F팀장",
    "AUDIT_UserDeviceService_imeiVal": "imeiVal",
    "Title_000001125": "중장기발전계획 수립추진 T/F팀장",
    "Title_000001126": "부장",
    "Title_000001127": "경영기획부장",
    "Title_000001128": "총무부장",
    "RoleVisitorAdmin": "방문자관리자",
    "MdmPolicyControlName_DevicePasswordExpiration": "비밀번호 유효기간 설정.",
    "AL_OfficeAppLog": "업무앱 로그",
    "ParentDeptApply": "선택적용",
    "LANG_ManageGPS": "GPS 관리",
    "Title_000001120": "부단장",
    "LANG_RoleUser": "사용자",
    "LANG_APP_removeTargetInfo": "앱 제거 적용 대상",
    "AUDIT_BeaconAreaService_updateDate": "갱신시간",
    "ISSUE_SOLVE_ERROR_AdminLocked": "사용자가 지정된 암호 실패횟수를 초과하여 잠금 상태가 되었습니다. 잠금을 푸실려면 \"설정\"->\"관리자 관리\" 에서 \"잠금해제\" 를 하십시오.",
    "ACTION_SystemLocked": "단말 인증 오류로 인한 시스템 잠김",
    "Title_000001152": "정보화팀장",
    "ERROR_ReachedMaxSessionCount": "최대허용세션초과",
    "Title_000001151": "전략기획팀장",
    "Title_000001150": "경영혁신팀장",
    "ERROR_NO_PHONENUMBER": "전화번호가 없습니다. USIM을 확인해 주세요.",
    "Title_000001159": "연구기획팀장",
    "Title_000001158": "기술연구팀장",
    "Title_000001157": "교육훈련센터",
    "Title_000001156": "해상안전실장",
    "AUDIT_ThirdPartyCompanyService_id": "ID",
    "Title_000001155": "선체제도팀장",
    "Title_000001154": "기관제도팀장",
    "parentName": "상위부서",
    "LANG_POLICY_CONDITION_TITLE_TYPE_SELECT": "정책조건 선택",
    "MdmPolicyControlName_ScheduledInstallTime": "IT 관리자가  업데이트 설치의 설치날짜 가능 시간.",
    "AUDIT_AppService_appType": "앱종류",
    "AUDIT_UserService_visitorPolicyUrl": "방문자정책URL",
    "MDMx4011": "사용자상태(Status) 정보가 이미 등록되어 있습니다.",
    "MDMx4012": "사용자상태(Status) 정보를 등록하는데 실패하였습니다.",
    "targetId": "대상 아이디",
    "MDMx4010": "사용자상태(Status) 정보가 없습니다.",
    "Configuration_passwordFailureMax_DESC": "관리 페이지의 관리자/사용자 패스워드 실패 횟수를 설정합니다. (단위 : 회, 기본값 : 5, 범위 : 1~5)",
    "AUDIT_AppService_aliasGroup": "별칭 사용",
    "LANG_POLICY_add": "정책 추가",
    "Title_000001140": "경영예산실장",
    "AUDIT_AppService_versionName": "버전명",
    "LANG_TOP_gotoMain": "메인으로",
    "Title_000001142": "총무인사팀장",
    "Title_000001141": "사업개발팀장",
    "LANG_GPS_Arount_address": "주변",
    "Title_000001148": "총무회계팀장",
    "AUDIT_AppService_tag": "태그",
    "Title_000001147": "인력개발팀장",
    "Title_000001149": "고객지원팀장",
    "Title_000001144": "검사제도팀장",
    "Title_000001143": "기술지원실장",
    "Title_000001146": "품질인증팀장",
    "LANG_beaconArea_Alert_Empty": "비콘 위치정보가 존재하지 않습니다. 먼저 비콘 위치정보를 등록하여야 합니다.",
    "Title_000001145": "기술사업팀장",
    "PASSWORD_QUALITY_ALPHABETIC": "문자포함",
    "AUDIT_AppService_updateDate": "갱신시간",
    "Title_000001800": "국제협력사업추진기획단팀장",
    "LANG_QrCode_Print_Desc": "Qr Code의 인쇄를 처리합니다.",
    "AUDIT_ThirdPartyDeptService_company": "업체",
    "MdmPolicyControlName_EnterpriseProtectedDomainNames": "기업 도메인 이름 보장.",
    "MDMx4020": "등록하려는 ID 는 이미 등록된 사용자(User)가 있습니다.",
    "MDMx4021": "이미 등록된 사용자상태(Status) 정보가 있습니다.",
    "ActivationExpression": "활성화 표현식",
    "MDMx4014": "사용자상태 보조 정보가(SubStatus) 없습니다.",
    "LANG_beaconArea_MODIFY": "비콘 위치정보 수정",
    "Title_000001171": "수석행정원",
    "MDMx4013": "사용자상태 보조 정보가(SubStatus) 이미 해지되어 있습니다.",
    "Title_000001170": "연구소기획단장",
    "LANG_OsName": "OS명",
    "MDMx4015": "등록된 사용자상태(Status) 정보가 없습니다.",
    "Title_000001175": "부지부장",
    "Title_000001174": "지부장",
    "Title_000001173": "부장직대",
    "Title_000001172": "수석검사원",
    "Title_000001179": "차장",
    "Title_000001178": "실장직대",
    "Title_000001177": "실장",
    "Title_000001176": "출장소장",
    "AUDIT_Pkcs12CertificateService_name": "명칭",
    "LANG_ExcelExport_Admin": "관리자목록",
    "NoticeTargetName": "대상명",
    "IsAllow": "허용여부",
    "AUDIT_AppService_id": "ID",
    "MdmPolicyControlName_allowSimple": "단순값 허용",
    "CompanyName": "업체명",
    "Title_000001160": "기술연구실장",
    "Title_000001162": "반장",
    "Title_000001161": "혁신전략실장",
    "Title_000001164": "경영기획실장",
    "LANG_LocationPolicy": "출입정책",
    "Title_000001163": "정부대행검사실장",
    "Title_000001166": "CI그룹장",
    "LANG_LocationCondition": "기지국 기반 위치조건",
    "AL_registerFail": "단말기 등록 실패",
    "Title_000001165": "경영지원실장",
    "Title_000001168": "해양사고방지센터장",
    "MESSAGE_ALERT_NO_SELECT_REMOTE_COMMAND": "원격 명령을 선택하여 주십시요.",
    "Audit_NoticeService": "설정>공지관리",
    "Title_000001167": "감사실장",
    "Title_000001169": "연구개발부장",
    "BUTTON_CONFIRM": "확인",
    "Configuration_isCompressDvc": "DVC 압축 여부",
    "LANG_hour14": "14시",
    "LANG_hour15": "15시",
    "LANG_hour16": "16시",
    "MESSAGE_ALERT_SELECT_TARGET_DEVICE": "좌측맵에서 대상단말기를 먼저 선택해주시기 바랍니다.",
    "LANG_hour17": "17시",
    "PasswordPolicySpecialChar": "특수문자",
    "LANG_hour18": "18시",
    "LANG_WARNING_LEVEL1_MSG": "INFO Level : 특정한 이벤트에 대한 로그",
    "LANG_hour19": "19시",
    "LANG_TotalDeviceC": "총단말기 수",
    "NoticeTargetList": "공지 적용 대상",
    "LANG_feb": "2월",
    "LANG_AGENT_LOG_REGISTER_FAILED": "단말등록에 실패 하였습니다.",
    "LANG_hour10": "10시",
    "LANG_hour11": "11시",
    "LANG_hour12": "12시",
    "LANG_hour13": "13시",
    "LANG_ManageProduceDevice": "단말 유형 관리",
    "LANG_Hourly": "시간별",
    "ModifyManageDevice": "단말 수정",
    "MdmPolicyControlName_pluginFiles": "MDM Plugin 파일명",
    "LANG_ManageGlobalCode": "코드 관리",
    "LANG_Windows_Location02": "위치 강제 ON.",
    "Audit_ThirdPartyDeptService": "설정>부서관리>부서",
    "LANG_Windows_Location00": "위치 강제 OFF.",
    "LANG_Windows_Location01": "위치 서비스 허용.",
    "LANG_hour05": "05시",
    "LANG_LOG_InstallLogDetail": "단말에 설치된 OS, Agent설치현황 등 전반적인 현황을 조회합니다.",
    "LANG_hour06": "06시",
    "LANG_hour03": "03시",
    "AL_backupOK": "백업 성공",
    "LANG_hour04": "04시",
    "LANG_hour09": "09시",
    "LANG_hour07": "07시",
    "LANG_ManagerDetail": "관리자 상세보기",
    "LANG_hour08": "08시",
    "LANG_PolicyLocationManagement": "출입관리",
    "MdmPolicyControlName_AllowUserToResetPhone": "유저에게 단말 초기화 허용.",
    "AUDIT_NoticeTargetService_createDate": "생성시간",
    "LANG_hour01": "01시",
    "LANG_hour02": "02시",
    "LANG_hour00": "00시",
    "LANG_LOC_notExistLocaionInfo": "단말기의 위치 정보가 존재하지 않습니다.",
    "reConnectDeviceMaximumMailBody": "에이전트 재설치 제한 횟수 초과 입니다. 디바이스 : {0}, 사용자 : {1}, 제한횟수 : {2}",
    "LANG_count2": "개",
    "LANG_DEVICE_TotalStatusDetail": "조직 및 OS별로 사용자의 단말정보, 정책, 설치앱 등의 정보를 조회합니다",
    "LANG_ALT_Statistics": "통계 페이지로 이동합니다.",
    "CUCCommand": "삭제/설치/업데이트",
    "ERROR_TokenVerification": "위변조 검증이 정상적으로 통과되지 않았습니다.",
    "Configuration_clientTimeoutSec_DESC": "단말기의 응답시간 제한 시간을 설정합니다. (단위 : 초, 기본값 : 600)",
    "AUDIT_UserService_title": "제목",
    "AUDIT_LocationService_userDevice": "사용자단말",
    "PasswdSettingRule3": "패스워드는 [{0},{1},{2}] 혼용으로 설정해야 합니다.",
    "PasswdSettingRule2": "패스워드는 [{0},{1}] 혼용으로 설정해야 합니다.",
    "LANG_jun": "6월",
    "PasswdSettingRule1": "패스워드는 [{0}] 로만 설정해야 합니다.",
    "LANG_jul": "7월",
    "AUDIT_ReservedVisitorService_email": "이메일",
    "AL_appKill": "앱 종료",
    "policyPublish": "정책 배포",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT_OUT": "비콘 출구 위치 선택",
    "RC_SYNC_APPS": "앱 정책 동기화",
    "AUDIT_ControlAPService_id": "ID",
    "LANG_duplicate": "{0} 이미 존재합니다.",
    "LANG_aug": "8월",
    "LANG_Currentstatus": "현재상태",
    "UnlockUser": "잠금해제",
    "LANG_Policy_WouldLikeChanege": "변경 하시겠습니까?",
    "AL_sdmounted": "SD 카드 삽입",
    "AL_agentError": "단말기 내부 에러",
    "AUDIT_VersionedAppService_hash": "해쉬값",
    "Notification_EmailTitle": "[MDM 서비스 보안 알림] {0}",
    "LANG_NonApplys": "미적용된",
    "LANG_ManageLatiNotvalid": "위,경도가 유효하지 않습니다.",
    "LANG_REMOTE_BACKUP_STATUS": "복구실행명령을 한적이 없습니다.",
    "EVERYMONTH": "매월",
    "LANG_beaconArea_Detail": "비콘 위치정보",
    "LANG_Visisor_Statistics": "방문자 통계",
    "MdmPolicyControlName_allowAssistant": "Siri 허용",
    "LANG_POLICY_CONDITION_TITLE_TYPE_LOCATION_BUTTON_DETAIL": "위치 리스트 보기",
    "LANG_ManageAddressNotvalid": "주소가 유효하지 않습니다.",
    "AUDIT_UserService_lastAccessIp": "마지막 접속IP",
    "LANG_oct": "10월",
    "MdmPolicyControlName_RestrictAppToSystemVolume": "설치된 어플리케이션이 시스템 드라이버의 데이터 제한허용.",
    "LANG_POLICY_callBlockingOn": "외부 전화걸기 차단 (Android)",
    "LANG_ipPatternis2": "관리자가 접속하는 대상IP의 패턴을 뜻합니다. 예) 192.168.0.X",
    "MdmPolicyControlName_allowAppRemoval": "앱 제거",
    "LANG_ipPatternis1": "IP패턴이란?",
    "AUDIT_UserDeviceService_lockCnt": "Lock횟수",
    "AUDIT_UserService_name": "명칭",
    "AUDIT_ProductDeviceService_binaryFilePath": "파일경로",
    "Configuration_adminAccessIP2_DESC": "허용 접속 IP 2 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "DuplicateUsernameEmail": "사용자 아이디나 이메일이 중복입니다.",
    "AL_restoreOK": "복구 성공",
    "MdmPolicyControlName_allowGameCenter": "Game Center 사용 허용",
    "LANG_Policy_Filter_check_desc": "오른쪽 체크박스를 체크하시면 OS타입별로 보이는 화면이 바뀝니다.",
    "MdmPolicyControlName_forceEnabledMobileData": "데이터 네트워크 사용 강제화",
    "LANG_BeaconAreaArea": "위치설명",
    "LANG_ManageBeaconAreaDetail": "MDM정책이 적용되는 위치에 설치된 비콘의 고유정보를 관리합니다.",
    "MdmPolicyControlName_allowCloudKeychainSync": "키체인 동기화  허용",
    "Label_LastSyncDate": "정책 적용 시간",
    "LANG_apr": "4월",
    "LANG_iPhone": "아이폰",
    "HHI_ERROR_AuthenticationFailed": "아이디,패스워드를 다시 확인하여 주십시오.",
    "LANG_AuditEntityName": "감사 대상",
    "LANG_hour23": "23시",
    "WhiteAppAppointmentTrue": "지정",
    "LANG_hour22": "22시",
    "LANG_hour21": "21시",
    "LANG_POLICY_APPLICATION_FAILED": "정책 적용 실패",
    "LANG_hour20": "20시",
    "MdmPolicyControlName_MDMPSP0000000007": "USB 테더링",
    "MdmPolicyControlName_MDMPSP0000000008": "USB 저장소",
    "MdmPolicyControlName_MDMPSP0000000009": "USB 디버깅",
    "MdmPolicyControlName_MDMPSP0000000015": "USB 화이트리스트",
    "Configuration_passwordMaxLength_ALERT": "{0} : 16으로 지정하여 주십시오.",
    "searcher": "조회자",
    "LANG_POLICY_LOCATION": "출입정책",
    "Configuration_deviceMaximumInactiveTime_ALERT": "{0} : 240~8760 사이입니다.",
    "AUDIT_NoticeService_createDate": "생성시간",
    "AUDIT_UserDeviceService_": "디바이스서비스",
    "RegisterVersion": "등록버전",
    "LANG_Policy_ChooseTarget": "삭제 대상을 선택하여 주세요.",
    "LANG_NEW_Users": "신규 사용자",
    "LANG_AddHoliday": "휴일 등록",
    "MdmPolicyControlName_allowVoiceDialing": "보이스 다이얼링 허용",
    "RoleSuperManager": "슈퍼관리자",
    "LANG_apr2": "4월",
    "LANG_Daily": "일별",
    "AUDIT_UserService_customUserType": "사용자타입구분",
    "EVERYDAY": "매일",
    "AUDIT_ThirdPartyDeptService_name": "명칭",
    "AUDIT_AppService_name": "명칭",
    "LANG_AGENT_LOG_REGISTER_SUCCEEDED": "단말등록에 성공 하였습니다.",
    "AUDIT_ReservedVisitorService_name": "이름",
    "SENT": "전송 완료",
    "LANG_LostWeekly": "금주 분실 건수",
    "LANG_AccessInPolicy": "출입 IN 정책 설정",
    "MESSAGE_ALERT_NOT_ALLOWED_GET_LOCATION": "사용자 설정에 의하여 위치정보를 조회할 수 없습니다.",
    "LANG_plzSelectCom": "업체를 선택해주세요.",
    "LANG_Password": "암호",
    "LANG_Self_Desc_warning_to_desc": "주의",
    "TermCount": "개수",
    "AUDIT_UserService_lastAccessTime": "마지막 접속시간",
    "AUDIT_PassingStatusService_name": "명칭",
    "AUDIT_UserService_credential": "CREDENTIAL",
    "LANG_Self_Device_info": "등록된 디바이스",
    "LANG_msgInsert": "입력이",
    "LANG_WelcomeLogin": "님이 로그인 하셨습니다.",
    "LANG_Self_Device_connect_status": "연결여부",
    "MdmPolicyControlName_maxInactivity": "최대 자동 잠금 시간 (분)",
    "AUDIT_VisitorUserService_employeeCompany": "방문직원 회사이름",
    "MdmPolicyControlName_allowScreenShot": "화면캡처 허용",
    "MESSAGE_ALERT_CONFIRM_MODIFY": "수정하시겠습니까?",
    "AL_common": "일반 로그",
    "MdmPolicyControlName_PWPOLICY00000001": "패스워드 사용",
    "PolicyControl_category_00006": "디바이스 통제",
    "PolicyControl_category_00005": "무선 및 네트워크 통제",
    "PolicyControl_category_00008": "단말정보 전송",
    "PolicyControl_category_00007": "디스플레이",
    "Configuration_passwordFailureMax": "패스워드 실패 횟수 제한",
    "PolicyControl_category_00009": "App 보안정책",
    "MdmPolicyControlName_AllowDeveloperTools": "개발자 툴 F12 허용.",
    "PolicyControl_category_00002": "에이전트관리정책",
    "PolicyControl_category_00001": "로그설정",
    "PolicyControl_category_00004": "예약 백업",
    "PolicyControl_category_00003": "단말인증",
    "AL_SamsungSDK": "삼성 SDK 비활성",
    "AUDIT_AppService_agentDeviceVendor": "MDM벤더",
    "LANG_NUMERIC_CHECK": "[{0}] 은/는 숫자만 입력 가능합니다.",
    "LANG_REMOTE_RECEIVE_PHONENUM": "발신번호",
    "Audit_ThirdPartyCompanyService": "설정>부서관리>업체",
    "PolicyControl_category_00011": "사파리",
    "PolicyControl_category_00010": "환경제한",
    "LANG_ModelName": "모델명",
    "CertificateType": "인증서 종류",
    "PolicyControl_category_00014": "프로파일암호",
    "PolicyControl_category_00013": "암호설정",
    "PolicyControl_category_00012": "암호환경",
    "LANG_AP_MODIFY": "AP(Access Point) 수정",
    "LANG_POLICY_notSelectedTarget": "대상이 선택되지 않았습니다.",
    "LANG_SuccessToSave": "저장에 성공하였습니다.",
    "AUDIT_UserDeviceService_lastSyncTime": "최종동기시간",
    "LANG_AccessInPolicyDesc": "출입 IN 일때의 정책항목들을 설정합니다.",
    "Configuration_passwordMinLength": "패스워드 최소 길이",
    "handleIssue": "해결하기",
    "AUDIT_UserTitleService_name": "명칭",
    "RC_APP_RUN": "앱 실행",
    "AL_AOMErr": "AOM 푸쉬 등록 실패",
    "LoginSessionExpired": "로그인 세션이 종료되었습니다. 다시 로그인해 주십시오.",
    "AUDIT_VisitorUserService_email": "이메일",
    "AlertSelectTarget": "타겟을 선택하십시오.",
    "LANG_DEVICE_fistSelectDeviceLeftmap": "좌측맵에서 대상단말기를 먼저 선택해주시기 바랍니다",
    "LANG_plzSelectParamO": "{0}을 선택해 주세요.",
    "MdmPolicyControlName_CellularAppDownloadMBLimit": "셀룰러상에서 앱 다운로드 제한. (MB)",
    "AuditDifference": "변경 데이터",
    "RC_ERROR_ON_SENDING": "명령전송실패",
    "LANG_plzSelectParamR": "{0}를 선택해 주세요.",
    "ACTION_DeviceMDMService_getMdmCommands": "단말 원격 명령 수신 통신",
    "LANG_PropertyValueModify": "설정값 수정",
    "LANG_APP_WhiteAppManagementShort": "화이트앱관리",
    "ErrorMessage": "에러",
    "AUDIT_VersionedAppService_appType": "앱종류",
    "LANG_ManagerName": "관리자명",
    "AUDIT_AppService_hash": "해쉬값",
    "LANG_sourceDevice": "대상단말기",
    "BUTTON_CLOSE": "닫 기",
    "Configuration_licenseCode": "MDM 라이선스 코드",
    "MdmPolicyControlName_allowCloudDocumentSync": "문서 동기화  허용",
    "TargetDept": "부서",
    "LANG_SMS_COMPLETE": "SMS전송 완료",
    "MdmPolicyControlName_allowGlobalBackgroundFetchWhenRoaming": "로밍 시 자동 동기화 허용",
    "deviceAppInfo": "단말 앱 정보",
    "AUDIT_ReservedVisitorService_visitorDeptName": "방문부서",
    "AUDIT_NoticeService_updateDate": "갱신시간",
    "AL_ProfileCreateToNormal": "단말 프로파일 생성",
    "ERROR_DBLimitWarning": "저장소의 허용용량 경고 제한 비율에 도달하였습니다. 저장소 확보에 대한 조치를 하여야 합니다.",
    "LANG_NOTICE_Latest": "최근 공지",
    "LANG_LOG_LogManagement": "로그",
    "LANG_Android": "안드로이드",
    "BUTTON_CANCLE": "취소",
    "execResult": "실행결과",
    "LANG_POLICY_CONDITION_LOCATION": "기지국",
    "AjaxCommunicationError": "Ajax 통신 에러. 다시 시도해 주십시오.",
    "BUTTON_TERMINATE": "폐기",
    "LANG_LOC_latitude": "위도",
    "java.lang.Exception": "{0}",
    "LANG_POLICY": "정책",
    "LANG_ManageCompany": "업체 관리",
    "LANG_SMS_NotUsed": "SMS 기능을 사용하지 않습니다.",
    "AUDIT_Pkcs12CertificateService_notAfterDate": "인증서종료일자",
    "AUDIT_UserService_passwordConfirm": "비밀번호확인",
    "LANG_Windows_Password_Character03": "숫자+영/대소문자+특수문자.",
    "manager": "관리자",
    "LANG_APP_publishInfo": "배포 앱 정보",
    "LANG_Windows_Password_Character02": "숫자+영/대소문자.",
    "LANG_Windows_Password_Character01": "숫자+영문소문자.",
    "AUDIT_UserService_iosDownLoadUrl": "IOS Download URL",
    "LANG_Windows_Password_Character00": "숫자 전용.",
    "LANG_searchDate": "검색 기간",
    "ERROR_UserLocked": "사용자 지정된 암호 실패{0}로 잠금 상태가 되었습니다.",
    "LANG_ALT_policyManagement": "MDM 제어를 위한 정책을 관리합니다.",
    "LANG_CreateDate": "생성일",
    "SETTING_CATEGORY_1": "보안 기본 설정 정보",
    "AUDIT_UserService_windowsMDMUse": "윈도우MDM여부",
    "LANG_WP_federated_enrollment_ERROR_UserLocked": "사용자가 잠금상태입니다. 시스템 관리자에게 문의하여 주세요.",
    "APPCONTROLBLACK": "블랙앱",
    "LANG_LastestSendDate": "단말상태 미전송현황",
    "AL_appInstall": "앱 설치",
    "Configuration_adminAccessIP3_DESC": "허용 접속 IP 3 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "ALERT_TO_GPS_POINT": "GPS의 위치값은 4 Point 이상이어야 합니다",
    "LANG_ExcelExport_UserDeviceSum": "단말현황집계",
    "LANG_REMOTE_LOST_ING_REPORT_MESSAGE": "분실 / 도난 신고 처리 중.",
    "LANG_POLICY_Publish": "정책 배포하기",
    "RC_RM": "중요 정보 삭제",
    "SecurityIssueAlert_Title": "보안 이슈 해결",
    "ERROR_DeviceRegistrationCnt": "에이전트 설치 제한 개수를 초과하였습니다.",
    "SECEND15": "15초",
    "SETTING_CATEGORY_2": "관리자 설정 정보",
    "SETTING_CATEGORY_3": "단말기 설정 정보",
    "SETTING_CATEGORY_4": "패스워드 정책",
    "ERROR_insertReservedVisitor": "예약 방문자 등록실패 입니다.",
    "LANG_APP_AppManagementDetail": "업무앱, 화이트앱/블랙앱 및 기타 앱관리를 수행합니다.",
    "LANG_aug2": "8월",
    "MdmPolicyControlName_RequireProtectionUnderLockConfig": "잠김 구성의 보호여부 필수 여부.",
    "LANG_sat": "토",
    "AUDIT_UserDeviceService_mobileNumber": "모바일번호",
    "LANG_DeviceRemoteManage": "원격 관리",
    "LANG_CompanyName": "사용업체명",
    "LANG_EXECUTION_FAILED": "푸쉬 실행실패(서버에러).",
    "MdmPolicyControlName_AllowWiFiHotSpotReporting": "WiFi 핫스팟  자동알림 설정여부.",
    "LANG_LOC_cellid": "Cell ID",
    "LANG_WP_federated_enrollment_ERROR_DeviceIsNotActivatedForUse": "단말유형을 활성화하여야 사용이 가능합니다. 시스템 관리자에게 문의하여 주세요.",
    "ISSUE_SOLVE_GUIDE_Title_DeviceManagerDisabled": "MDM 기기관리자 등록 안내",
    "LANG_msgDelete": "삭제가",
    "LANG_APlist": "무선 AP 리스트",
    "AUDIT_UserDeviceService_heartbeatDateTime": "하트비트시간",
    "AL_LocationInfoFail": "단말 위치정보 습득 실패",
    "MdmPolicyControlName_minComplexChars": "복잡한 문자 최소 개수",
    "AUDIT_VersionedAppService_certificate": "인증",
    "DeviceResource_2004": "배터리 상태",
    "DeviceResource_2003": "가용 메모리",
    "DeviceResource_2006": "외부저장소 가용 용량",
    "MdmPolicyControlName_EnterpriseModeSiteList": "기업 사이트의 특정 URL을 유저에게 하용.",
    "DeviceResource_2005": "외부저장소 총 용량",
    "LANG_Platform": "플랫폼",
    "DeviceResource_2002": "총 메모리",
    "codeValue": "코드값",
    "DeviceResource_2001": "CPU 사용량",
    "AUDIT_VersionedAppService_installedAppVersion": "인스톨앱버전",
    "SAFARIACCEPTCOOKIES_ALLWAYS": "항상",
    "MdmPolicyControlName_muteMic": "음성 녹음",
    "PASSWORD_QUALITY_UNSPECIFIED": "제약없음",
    "AlertMailSubject": "[경고] 앱 위변조가 탐지 되었습니다.",
    "MdmPolicyControlName_AllowActionCenterNotifications": "액션센터 알림 허용.",
    "MESSAGE_ALERT_CERTIFICATES_FILEEXT_CHECK": "해당 확장자의 파일은 업로드 할 수 없습니다.",
    "MdmPolicyControlName_sendPeriodFatalLog": "중요 로그 전송 주기",
    "LANG_ReservedVisitorManagement_KAI_competent": "담당자",
    "IsPushEnable": "원격통신",
    "LANG_RetainSession": "세션 자동 유지중",
    "LANG_Inquirer": "조회자",
    "LANG_APP_Use_PresentCondition": "앱 사용 현황",
    "LANG_Self_Device_find_location": "위치 찾기",
    "LANG_CONFIRM_TO_Delete": "삭제 하시겠습니까?",
    "BUTTON_UPDATE": "업데이트",
    "AUDIT_VersionedAppService_installedDate": "인스톨일자",
    "LANG_mon": "월",
    "WhiteAppAppointmentFalse": "해제",
    "AddHoliday": "휴일 추가",
    "AL_AppsInfoFail": "단말에 설치된 어플 조회 실패",
    "LANG_Self_Device_find_location_desc": "잃어버린 디바이스의 현재 위치를 확인할 수 있습니다.",
    "LANG_UploadAppFile": "앱파일 업로드",
    "LANG_NOTICE_Send2": "전송",
    "respAdmin": "책임관리자",
    "AUDIT_UserDeviceService_statusCode": "상태코드",
    "ACTION_SamsungSDK": "삼성 SDK 가 비활성 상태입니다.",
    "AUDIT_VisitorUserService_complete": "방문끝냄",
    "LANG_PackageId": "패키지명",
    "MdmPolicyControlName_allowAssistantWhileLocked": "장비가 잠겨 있는 동안 Siri 허용",
    "DeviceResource_2008": "내부저장소 가용 용량",
    "DeviceResource_2007": "내부저장소 총 용량",
    "LANG_sep": "9월",
    "LANG_SETTING_SystemSettings": "시스템설정",
    "AUDIT_DefenceSettingService_propertyValue": "설정값",
    "AUDIT_VisitorUserService_employeePosition": "직원 직위",
    "AUDIT_UserService_accountNonLocked": "ACCOUNT NON LOCKED",
    "ERROR_DeviceInactiveMaximumTime": "단말이 지정된 시간보다 더 오랫동안 접속한 기록이 없습니다.",
    "MdmPolicyControlName_allowYouTube": "YouTube 사용 허용",
    "AUDIT_VisitorUserService_createDate": "생성일자",
    "EditSecurityIssue": "보안 이슈 수정",
    "LANG_ExcelExport_User": "사용자목록",
    "RoleVisitorManager": "방문자매니저",
    "RC_POLICY_ON": "단말정책 재적용 (Android)",
    "AUDIT_UserDeviceService_nowPolicyControl": "최종적용정책항목",
    "MdmPolicyControlName_AllowSearchSuggestionsinAddressBar": "주소창에서 검색제안 허용.",
    "LANG_LastAccessIp": "접속 IP",
    "LANG_severity": "심각도",
    "TabVerificationLogs": "검증 로그",
    "RC_RESTORE": "복구",
    "BUTTON_DEL": "삭제",
    "LANG_App_Upload_WhiteApp_is_Exists": "허용 앱 이 이미 존재합니다. ",
    "AUDIT_UserDeviceService_name": "명칭",
    "DeviceUser": "사용자",
    "AUDIT_HolidaysService_holidayDesc": "휴일 상세",
    "ModifyUser": "사용자 수정",
    "LANG_POLICY_CONDITION_TIME": "Time",
    "AUDIT_NoticeService_id": "ID",
    "MdmPolicyControlName_AllowSimpleDevicePassword": "간편 비밀번호 허용.",
    "LANG_APP_OfficeAppManagement": "업무앱관리",
    "LANG_WP_federated_enrollment_ERROR_AuthenticationFailed": "사용자 인증이 실패하였습니다. 이메일주소에 해당하는 사용자아이디 혹은 비밀번호를 확인하여 주시기 바랍니다.",
    "deviceCondition_summary": "관리하고 있는 단말기들에 대한 전반적인 정보를 볼 수 있는 페이지입니다",
    "AL_registerOK": "단말기 등록 완료",
    "DuplHolidayError": "이미 지정된 공휴일이 있습니다.",
    "AUDIT_AppService_virusResult": "바이러스체크",
    "LANG_CONFIRM_TO_Apply": "적용하시겠습니까?",
    "AUDIT_Pkcs12CertificateService_serialNumber": "시리얼넘버",
    "LANG_SecurityManagement": "보안 관리",
    "MdmPolicyControlName_allowSaveLogInternal": "로그 내부 저장",
    "controlItemValue": "설정값",
    "LANG_execResult": "실행결과",
    "LANG_AccessOutPolicy": "출입 OUT 정책 설정",
    "LANG_POLICY_CONDITION_WIFI": "WiFi-AP",
    "LANG_APP_NoneAppManagement": "기타앱관리",
    "LANG_POLICY_PolicyResources": "정책자원관리",
    "ERROR_DEPTDEL_EXIST_SUB": "하위 부서 또는 사용자가 존재하여 삭제할 수 없습니다.",
    "Title_000001400": "사무원",
    "LANG_noRecord": "표시할 행이 없습니다.",
    "CertificateAlias": "인증서 별칭",
    "LANG_LOG_IssueLog": "보안이슈로그",
    "LANG_DEVICE_PositionInfomation": "단말정보",
    "LANG_Applys": "적용된",
    "LANG_APP_WhiteAppAdd": "화이트 앱 추가",
    "AppName": "앱명",
    "Vendor": "제조사",
    "AUDIT_Pkcs12CertificateService_password": "인증서암호",
    "RC_APP_STOP": "앱 종료",
    "AUDIT_AppService_officeApp": "오피스앱여부",
    "LANG_REMOTE_LOST_NOT_REPORT_MESSAGE": "분실 /도난 신고 안됨.",
    "MdmPolicyControlName_AllowAppStoreAutoUpdate": "스토어로부터 설치된 앱 자동업데이트 허용.",
    "MdmPolicyControlName_MaxInactivityTimeDeviceLock": "장치 잠금 최대 유휴시간 설정.",
    "ACTION_DeviceService_isHoliday": "휴일여부조회",
    "LANG_APP_CompanyName": "사용업체명",
    "PackageName": "패키지명",
    "LANG_Windows_Password_Required01": "숫자 필수 그리고 비밀번호 필수.",
    "AUDIT_ThirdPartyDeptService_createDate": "생성시간",
    "Lang_DeviceSumOther": "기타",
    "LANG_Windows_Password_Required00": "영문+숫자 필수 그리고 비밀번호 필수.",
    "PolicyControl_new_category_desc_6000": "Windows OS 단말기의 장치 관리를 위한 정책항목을 설정합니다.",
    "Title_000001000": "PM",
    "ALLOW_TELEMETRY_ALLOWED": "허용",
    "LANG_Windows_Password_Required02": "유저가 선택.",
    "LANG_logMessage2": "메 세 지",
    "Title_000001001": "PL",
    "Title_Clerk": "사원",
    "PolicyControl_new_category_3002": "암호 정책",
    "PolicyControl_new_category_3003": "관리자 모드",
    "MdmPolicyControlName_sendErrorLog": "에러 로그 전송",
    "PolicyControl_new_category_3004": "iCloud 통제",
    "PolicyControl_new_category_3005": "Safari 통제",
    "PolicyControl_new_category_3000": "일반",
    "LANG_modifyWhiteApp": "화이트 앱 수정",
    "AUDIT_Pkcs12CertificateService_jksFile": "jks파일명",
    "LANG_AuditOperation": "감사 작업",
    "LANG_TOP_StatisticsLog": "통계로그",
    "LANG_LOG_LostManagement": "도난분실현황",
    "Operation_CREATE": "생성 완료",
    "AL_UsbStorage": "USB 저장소",
    "LANG_LocationPolicyNonApplys": "미적용",
    "LANG_POLICY_list": "정책 항목",
    "LANG_DEVICE_TotalInfoDetail": "좌측맵을 클릭하시면 해당정보를 보실 수 있습니다.",
    "LANG_SESSION_TIMEOUT": "관리자 로그인 세션이 만료되었습니다.",
    "LANG_REMOTE_LOST_NOT_ING_REPORT_MESSAGE": "분실 / 도난 신고 해제 처리 중.",
    "AUDIT_BeaconAreaService_name": "명칭",
    "LANG_Policy_NoSelectedPolicy": "선택된 정책이 없습니다.",
    "ALLLOG": "전체로그 전송",
    "AUDIT_ThirdPartyDeptService_updateDate": "갱신시간",
    "LANG_ManageOrganization": "조직 관리",
    "Audit_NoticeTargetService": "설정>공지관리>공지대상",
    "AUDIT_Pkcs12CertificateService_subjectDn": "서브젝트DN",
    "LANG_SETTING_DeviceTypeManagement": "단말유형관리",
    "LANG_LOC_description": "설명",
    "AUDIT_VersionedAppService_versionName": "버전명",
    "AUDIT_UserDeviceService_lastVersion": "최종버전",
    "AUDIT_UserService_membernum": "사번",
    "LANG_AdminLockedUserMessage": "잠금처리된 아이디입니다. 관리자에게 문의하십시오.",
    "LANG_POLICY_PolicyConfig": "정책설정",
    "Audit_UserService": "설정>사용자관리",
    "logDateTime": "조회일시",
    "AuditEntityOriginal": "원본 데이터",
    "LANG_NOTICE_ValidateDate_ALERT": "종료일자는 시작일자 이전으로 지정할 수 없습니다.",
    "LANG_INITPW_ITEM_SEND": "전송",
    "LANG_SelectDeviceDetail": "좌측맵에서 대상단말기를 먼저 선택해주시기 바랍니다.",
    "LANG_WP_federated_enrollment_item_user_id": "사용자아이디",
    "AUDIT_VersionedAppService_agentDeviceVendor": "MDM벤더",
    "codeDesc": "설명",
    "MdmPolicyControlName_AllowManualMDMUnenrollment": "유저 MDM수동 해제 처리.",
    "LANG_parentName": "상위부서",
    "LANG_IsLost": "도난/분실",
    "AL_policyApplyOK": "정책 적용 성공",
    "MdmPolicyControlName_MDMWNS0000000005": "WiFi Hotspot",
    "LANG_LoginID": "아이디",
    "MdmPolicyControlName_MDMWNS0000000004": "VPN",
    "MdmPolicyControlName_MDMWNS0000000003": "블루투스 / 블루투스 테더링",
    "LANG_HolidayList": "휴일 리스트",
    "MdmPolicyControlName_MDMWNS0000000002": "3G / 4G",
    "Configuration_adminAccessIP_ALERT": "{0} : 올바르지 않은 IP 입니다.",
    "MdmPolicyControlName_MDMWNS0000000001": "WiFi / WiFi Direct",
    "MdmPolicyControlName_pinHistory": "암호 기록 개수",
    "policyPublishNoTarget": "적용 대상을 선택하여 주세요.",
    "Version": "버전",
    "deviceLostMsg": "메 세 지",
    "LANG_APP_BlackAppAdd": "블랙앱 추가",
    "LANG_APP_publish": "앱 배포",
    "ACTION_DeviceService_registerDevice": "단말 등록 시도",
    "LANG_USR_AddUser": "사용자 관리",
    "MdmPolicyControlName_maxFailedAttempts": "실패한 시도 최대 횟수",
    "AUDIT_UserDeviceService_unlockToken": "Unlock토큰",
    "LANG_APP_Deselect": "해제",
    "LANG_POLICY_COMMENT_SelectCondition": "원하시는 정책조건을 선택하십시오.",
    "Configuration_dbmsCriticalLimitsize": "DBMS SERVER 허용용량 초과 제한 비율",
    "Configuration_passwordChangePeriod_ALERT": "{0} : 3~5 사이입니다.",
    "AUDIT_PassingStatusService_id": "ID",
    "MdmPolicyControlName_useTimeOutFeatureOfTheScreen": "화면 자동 잠금 사용",
    "APPCONTROLNONE": "제어안함",
    "LANG_SMS_RESEND": "SMS재전송 완료 ",
    "LANG_LOGIN_PASSWORD_CHANGE_MESSAGE2": "패스워드 {0}일 이내에 변경해 주십시오.",
    "LANG_LOGIN_PASSWORD_CHANGE_MESSAGE1": "패스워드 변경할 시기가 {0}일 지났습니다.",
    "NoticeStartDate": "공지시작일",
    "LANG_PERSONNEL_ReservedVisitorManagementLatest": "최근 방문자 예약",
    "AUDIT_NoticeService_content": "내용",
    "LANG_CATEGORY_STATISTICS": "통 계",
    "LANG_REMOTE_LOST_FOUND_MSG": "도난분실해제",
    "LANG_LogDate": "발생시간",
    "LANG_APP_publishInfoDetail": "배포할 앱의 상세정보 입니다.",
    "LANG_IsNotLostIng": "도난/분실 해제처리중",
    "MdmPolicyControlName_AllowUSBConnection": "USB 연결 허용.",
    "LANG_APP_WhiteAppState": "화이트앱 설치현황",
    "LANG_WindowPolicy": "Window 정책",
    "LANG_PolicyLogAppRemo": "정책/로그/설치앱/원격",
	"LANG_OTP": "OTP",
    "LANG_ALT_DeviceCondition": "단말종합현황 페이지로 이동합니다.",
    "MdmPolicyControlName_AllowLocation": "위치 허용.",
    "NoticeNewsTarget": "공지 대상 선택",
    "PASSWORD_QUALITY_COMPLEX": "특수문자포함",
    "LANG_POLICY_PolicyConfigPassing": "출입정책 설정",
    "LANG_Condition": "현황",
    "AUDIT_ReservedVisitorService_isVisiting": "방문자방문여부",
    "LANG_isRequired": "{0} 입력은 필수입니다.",
    "LANG_targetName": "대상 이름",
    "LANG_POLICY_PolicyConfigDetail": "단말에 대한 정책과 정책 대상을 설정합니다.",
    "AUDIT_ControlAPService_apDesc": "AP 상세",
    "ALWAYSON": "항상켜짐",
    "LANG_plzSelctOneRow": "하나의 행을 선택하세요.",
    "AUDIT_AppService_category": "앱 분류  ",
    "MdmPolicyControlName_AllowVoiceRecording": "보이스 레코딩 허용.",
    "LANG_ALT_noticeManagement": "단말 사용자에게 보낼 공지를 관리합니다.",
    "AddManageDevice": "단말 추가",
    "CompanyEditPopup": "업체 수정",
    "LANG_INITPW_REQUIRE_PASSWORD": "비밀번호를 정확히 입력하여 주세요.",
    "LANG_Validation_alert_beginDate_fail": "검색 시작일이 종료일보다 앞선 날짜입니다.",
    "LANG_TABLE_TO_NO_LIST": "조회된 값이 없습니다.",
    "LANG_PolicyOut": "OUT 정책",
    "LANG_DEVICE_BaseInfo": "기본정보",
    "LANG_row": "항목",
    "AddNotice": "공지 추가",
    "MdmPolicyControlName_LocalDeviceName": "블루투스 이름 설정 여부.",
    "LANG_feb2": "2월",
    "MdmPolicyControlName_AlphanumericDevicePasswordRequired": "장치 비밀번호 알파벳+숫자 필수.",
    "AL_LocationInfoOK": "단말 위치정보 습득 성공",
    "AL_Rooting": "단말 루팅",
    "Status_CLOSED": "종료",
    "AUDIT_Pkcs12CertificateService_isTerminated": "폐기여부",
    "RC_GET_LOCATION": "단말기 위치 조회",
    "LANG_POLICY_PolicyResourcesDetail": "MDM정책이 실행되는 위치정보를 관리합니다.",
    "FINISHED": "단말 실행 완료",
    "LostIsLock": "잠금실행",
    "PolicyControl_new_category_4002": "위치정보 관리정책",
    "WLAN_SCANMODE_NORMAL": "정상",
    "LANG_POLICY_InvokedTargetList": "적용된 대상 리스트",
    "PolicyControl_new_category_4001": "에이전트 관리정책",
    "PolicyControl_new_category_4000": "로그 관리 정책",
    "MdmPolicyControlName_AllowWindowsTips": "윈도우 팁과 소프트 랜딩 사용여부.",
    "LANG_jul2": "7월",
    "LANG_LOC_remoteCommandList": "단말 원격 명령 이력조회",
    "LANG_WP_federated_enrollment_ERROR_DeviceIsNotSupported": "지원하지 않는 단말유형입니다. 시스템 관리자에게 문의하여 주세요.",
    "LANG_ManagerConfigDetail": "MDM관리페이지에 대한 관리자를 설정합니다.",
    "LANG_UserLockedUserMessage": "잠금처리된 아이디입니다. 관리자에게 문의하십시오.",
    "LANG_REMOTE_LOST": "분실 / 도난 신고를 하시겠습니까? ",
    "CertIsTerminated": "폐기",
    "ISSUE_SOLVE_ERROR_DeviceIsNotSupported": "지원되지 않는 장치 모델을 활성화하기 위하여 단말유형관리 메뉴를 이용하여 주세요.",
    "MDMx0000": "성공",
    "LANG_STAND_BY": "푸쉬 전송준비중.",
    "sourceType": "로그소스",
    "LANG_sourceUser": "대상사용자",
    "AUDIT_UserDeviceService_moduleInstalled": "모듈설치여부",
    "LANG_Security_Issue": "보안이슈",
    "LANG_DetailDesc": "상세정보",
    "AUDIT_ThirdPartyDeptService_extCode": "EXT CODE",
    "SourceType_USER_ACTION": "사용자",
    "MdmPolicyControlName_passwordQuality": "패스워드 유형",
    "PasswordConfirmError": "패스워드와 패스워드확인 값이 다릅니다.",
    "RoleType": "사용자 등급",
    "LANG_jun2": "6월",
    "PolicyControl_new_category_desc_2003": "단말기의 앱의 실행, 제어, 삭제 관리를 위한 정책을 설정합니다.",
    "MESSAGE_ALERT_SUCCESS_REQUEST": "{0} 요청이 정상적으로 처리 되었습니다.",
    "PolicyControl_new_category_desc_2002": "단말기의 네트워크 장치를 제어하기 위한 정책을 설정합니다.",
    "PolicyControl_new_category_desc_2004": "단말기의 예약 백업 관리 정책을 설정합니다.",
    "ERROR_ON_EXECUTING": "실행 실패",
    "jqGrid_refresh": "새로고침",
    "Audit_UserDeviceService": "단말기관리>단말종합현황",
    "LANG_Policy_Not_Delete": "기본 정책은 삭제할 수 없습니다.",
    "policyCondition": "정책 조건",
    "Configuration_sessionMaxInactiveInterval": "세션 자동 종료 제한 시간",
    "AUDIT_UserDeviceService_commonPolicyVer": "일반정책버전",
    "ProductDeviceImage": "단말이미지",
    "LANG_APP_remove": "디바이스 앱 제거",
    "NoticeContent": "공지내용",
    "AUDIT_UserService_passingCardNo": "출입카드번호",
    "AUDIT_ThirdPartyCompanyService_updateDate": "갱신시간",
    "LANG_REMOTE_LOST_SEND_MSG": "도난분실신고",
    "MdmPolicyControlName_allowAddingGameCenterFriends": "Game Center 친구추가 허용",
    "LANG_ExcelExport_OfficeAppInstall": "업무앱설치현황",
    "ModifyDept": "부서 수정",
    "LANG_BeaconProximityUUID": "위치UUID",
    "AUDIT_AppService_binaryFilePath": "파일경로",
    "LANG_POLICY_PolicyApplyStatusDetail": "정책적용현황을 정책별 조직별로 조회합니다.",
    "LANG_PolicyInternal": "INTERNAL 정책",
    "jqGrid_edit": "편집",
    "LANG_PolicyDesc": "정책 설명",
    "logResult": "결과",
    "LANG_wen": "수",
    "AUDIT_ReservedVisitorService_employeeName": "담당자",
    "LANG_plzSelectComDept": "업체나 부서를 선택해주세요.",
    "MdmPolicyControlName_AllowToasts": "장치 잠금 화면에서 토스트 알림 허용.",
    "AUDIT_BeaconAreaService_proximityUUID": "위치UUID",
    "LANG_BeaconConditionDesc": "비콘(Beacon) 기기를 이용한 출입정책조건을 설정합니다.",
    "LANG_APP_CertAppManagement": "인증서관리",
    "ADPR_AN": "숫자영문자",
    "LANG_Already_registered_officeApp": "Office App으로 이미 등록된 App 입니다.",
    "backupMng": "백업관리",
    "InvalidEmail": "이메일이 올바르지 않습니다.",
    "LANG_Policy_all_btn_desc": "적용여부의 전체/해제 버튼입니다.",
    "Configuration_deviceRegistrationCnt": "에이전트 설치 제한 개수",
    "MESSAGE_ALERT_CONFIRM_RELEASE": "해제하시겠습니까?",
    "NoticeTargetListDetail": "단말 사용자에게 전달할 공지사항의 적용 대상을 관리합니다.",
    "LANG_New_Users": "신규 사용자",
    "LANG_Self_Device_restore_device": "복구 실행",
    "MdmPolicyControlName_allowUnknownSources": "알수없는 출처 앱 설치 허용",
    "Audit_LocationService": "정책관리>정책자원관리>위치관리",
    "LANG_EXECUTION_IGNORED": "푸쉬 실행 무시됨.",
    "MESSAGE_ALERT_CONFIRM_FAIL_INIT": "초기화에 실패했습니다.",
    "ChangeDept": "부서변경",
    "LANG_INITPW_ITEM_PASSWORD": "새 비밀번호",
    "LANG_Policy_TargetIsOneMoreThan": "정책 적용 대상은 최소 하나 이상이어야 합니다.",
    "LANG_LOG_AuditLogDetail": "MDM관리자의 행위에 대한 감사로그를 조회합니다.",
    "LANG_POLICY_APPLICATION_WAIT": "정책 적용 대기중",
    "AUDIT_VisitorUserService_employeeName": "방문자이름",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BIZ_APP_SELECT": "업무앱 선택",
    "AUDIT_UserService_id": "ID",
    "AUDIT_Pkcs12CertificateService_createDate": "생성시간",
    "LANG_Officer": "임직원",
    "RC_LOST": "분실 신고",
    "orderNo": "순서",
    "WillNotSelectYourself": "상위부서로 자기자신을 선택할 수 없습니다.",
    "LANG_POLICY_TRANSFER_COMPLETE": "정책 전송 완료",
    "MdmPolicyControlName_pushSsl": "자체 푸쉬 SSL 여부",
    "PolicyControl_new_category_desc_2000": "단말기의 보안을 위한 암호 정책을 설정합니다.",
    "LANG_total": "전체",
    "PolicyControl_new_category_desc_2001": "단말기의 디바이스 장치를 제어하기 위한 정책을 설정합니다.",
    "Configuration_adminAccessIP2": "허용 접속 IP 2",
    "Configuration_adminAccessIP1": "허용 접속 IP 1",
    "HolidayDesc": "설명",
    "LANG_ERROR_UserSessionTimeoutUserMessage": "관리자 세션 타임아웃으로 로그아웃 되었습니다.",
    "Configuration_adminAccessIP4": "허용 접속 IP 4",
    "Configuration_adminAccessIP3": "허용 접속 IP 3",
    "AUDIT_AppService_allowedUse": "사용허용여부",
    "AUDIT_LocationService_updateDate": "갱신시간",
    "AUDIT_UserService_passwordChangeDate": "비밀번호 변경일자",
    "ACTION_SessionTimeout": "관리자 세션만료",
    "SubjectDn": "Subject DN",
    "AUDIT_UserDeviceService_registedDevice": "등록디바이드",
    "LANG_Position": "직위",
    "RC_FINISHED": "명령실행완료",
    "LogOut": "로그아웃",
    "LANG_ManageDevice": "단말 관리",
    "Configuration_deviceMaximumInactiveTime_DESC": "단말기의 서버 미접속 허용 시간을 설정합니다. (단위 : 분, 기본값 : 720)",
    "AUDIT_Pkcs12CertificateService_updateDate": "갱신시간",
    "LANG_dec": "12월",
    "LANG_GPSConditionDesc": "GPS 위치를 기반으로 출입정책조건을 설정합니다.",
    "LANG_APP_selected": "지정",
    "LANG_plzInsertParamR": "{0}를 입력해 주세요.",
    "LANG_POLICY_CONDITION_SETTING_VALUE": "설정값",
    "LANG_plzInsertParamO": "{0}을 입력해 주세요.",
    "reConnectDeviceMaximumMailSubject": "[경고] 에이전트 재설치 제한 횟수 초과 입니다.",
    "LANG_SubTotalSum": "중간합계",
    "LANG_AppVerificationLogs": "앱 검증 로그",
    "conditionValue": "조건코드",
    "LANG_POLICY_PolicySchedule": "정책전송예약",
    "ALLOW_LOCATION_NOT": "허용안함",
    "AUDIT_VersionedAppService_tag": "태그",
    "AUDIT_BeaconAreaService_major": "minor",
    "LANG_may2": "5월",
    "MdmPolicyControlName_AllowPopups": "팝업창 허용.",
    "AUDIT_UserService_createDate": "생성시간",
    "MdmPolicyControlName_AllowNFC": "NFC허용.",
    "LANG_LOG_InstallLogList": "설치현황목록",
    "ERROR_DeviceInfomationIsNotProvided": "잘못된 인증 요청 정보입니다.",
    "PasswdLengthRule": "패스워드 길이는 [{0} ~ {1}] 자로 제한합니다.",
    "LANG_APP_OfficeAppAdd": "업무앱 추가",
    "ERROR_10001": "등록되지 않은 전화번호입니다.",
    "LANG_LOG_DeviceLogDetail": "단말에서 발생한 주요 로그를 조회합니다.",
    "ERROR_10003": "사용기간이 만료된 전화번호입니다.",
    "ERROR_10002": "외주교육 미 완료상태입니다.",
    "ERROR_10005": "더 이상 단말을 등록 할 수 없습니다.",
    "ERROR_10004": "에러가 발생하였습니다. 관리자에게 문의하여 주세요.",
    "LANG_Policy_select_un_all": "전체선택해제",
    "BUTTON_REMOVE": "제거",
    "RC_RECEIVED": "수신중",
    "AUDIT_VersionedAppService_plistFilePath": "plist파일경로",
    "ALLOW_LOCATION_ALLOWED": "허용",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BIZ_APP_BUTTON_DETAIL": "업무앱 리스트 보기",
    "LANG_dayofweeks": "{0}요일",
    "Configuration_isCompressDvc_DESC": "앱 위변조를 검증하기 위한 동적 검증 코드의 압축 여부를 설정한다.",
    "ERROR_10008": "출입카드번호가 없습니다. 관리자에게 문의하여 주세요.",
    "ERROR_10009": "사용자 계정이 없습니다.  관리자에게 문의하여 주세요.",
    "ERROR_10006": "이미 등록된 외주인력 입니다.",
    "ERROR_10007": "사용자 번호가 이미 등록되어있습니다.",
    "unknownDevice": "미등록 단말기",
    "LANG_Policy_Priorities": "우선순위",
    "ERROR_10011": "외주관리시스템과의 연결이 올바르지 않습니다. 관리자에게 문의하여 주세요.",
    "ERROR_10010": "기타정보(근무장소, PM명, 소속부서)가 없습니다. 관리자에게 문의하여 주세요.",
    "LANG_changeDeptTitle": "상위부서 변경",
    "LANG_Visitor": "방문객",
    "MdmPolicyControlName_AllowCortanaAboveLock": "시스템이 잠김상태일때 코타나가 음성으로 상호작용 허용.",
    "ERROR_LDCC_http_not_ok": "롯데정보통신 서버 연결실패 이거나 등록되지 않은 전화번호 입니다.",
    "InstallVersion": "설치버전",
    "AUDIT_ControlAPService_name": "명칭",
    "LANG_LogIn": "로그인",
    "LANG_Group": "조직별",
    "BUTTON_INSTALL": "설치",
    "LANG_WP_federated_enrollment_user_auth_ok_message": "사용자 인증이 완료되었습니다. 확인버튼을 누르시면 계속 진행이 됩니다.",
    "LANG_TOP_Settings": "설정",
    "AUDIT_NoticeService_name": "명칭",
    "AUDIT_ReservedVisitorService_externalVisitNo": "방문자번호",
    "AUDIT_ThirdPartyDeptService_statusCode": "상태코드",
    "MdmPolicyControlName_forceEnabledBluetooth": "블루투스 사용 강제화",
    "RESULT_OK": "성공",
    "CertificateFile": "인증서 파일",
    "MdmPolicyControlName_allowLocationUpload": "위치 정보 수집",
    "Configuration_systemEmail_ALERT": "{0} : 올바르지 않습니다.",
    "MdmPolicyControlName_AllowInPrivate": "회사 네트워크에서 브라우져 비밀모드 허용.",
    "Configuration_securityEnabled_DESC": "관리자의 아이피 제한 기능을 설정/해제하도록 설정합니다.",
    "LANG_POLICY_conditionConfig": "정책 조건 설정",
    "MdmPolicyControlName_safariAcceptCookies": "쿠키 허용",
    "policyTargetTitle": "정책 적용 대상",
    "LANG_POLICY_InvokedTargetListDetail": "선택된 정책이 적용되어 있는 대상 리스트 입니다.",
    "LANG_NormalPolicy": "일반정책",
    "AUDIT_ControlAPService_bsID": "bsID",
    "sourceUsername": "대상아이디",
    "MdmPolicyControlName_AllowSharedUserAppData": "같은앱의 다중 유저 데이터 공유 허용.",
    "AUDIT_ThirdPartyDeptService_orderNum": "ORDER NUM",
    "MESSAGE_ALERT_CONFIRM_INIT": "초기화하시겠습니까?",
    "RC_RESET": "공장 초기화",
    "AUDIT_UserDeviceService_lost": "분실여부",
    "PolicyControl_new_category_2000": "암호 정책",
    "MdmPolicyControlName_DevicePasswordHistory": "과거 비밀번호 설정.",
    "handleClose": "이슈확인",
    "PolicyControl_new_category_2001": "디바이스 통제정책",
    "PolicyControl_new_category_2002": "네트워크 관리정책",
    "PolicyControl_new_category_2003": "앱 관리정책",
    "LANG_BeconCondition": "비콘 기기 조건",
    "controlId": "항목",
    "LANG_CompanyAddPopup": "업체 추가",
    "LANG_App_Upload_Version_Not_compared": "업로드 앱 보다 상위버전이 존재합니다. ",
    "AUDIT_VersionedAppService_id": "ID",
    "PolicyControl_new_category_2004": "백업 관리정책",
    "LANG_msgModify2": "수정",
    "AUDIT_UserDeviceService_admin": "관리자",
    "AUDIT_ReservedVisitorService_createDate": "생성시간",
    "ManageWhiteApps": "화이트앱관리",
    "AUDIT_Pkcs12CertificateService_type": "인증서분류",
    "MdmPolicyControlName_allowMultiplayerGaming": "멀티 플레이어 게임 허용",
    "AUDIT_ThirdPartyDeptService_dept": "부서",
    "AppExcute": "앱실행",
    "RC_APP_REMOVE": "앱 삭제",
    "AUDIT_UserDeviceService_lastAccessTime": "최종접속시간",
    "ACTION_MdmLogController_setClosed": "보안 이슈 종료",
    "ISSUE_SOLVE_ERROR_DBLimitCritical": "저장소의 허용용량 초과 제한 비율에 도달하였습니다. 저장소 확보에 대한 조치를 하여야 합니다.",
    "LANG_DEVICE_RemoteCommandShort": "단말원격명령",
    "LANG_LOG_DeviceLatest": "최근단말로그",
    "Title_CEO": "대표이사",
    "MdmPolicyControlName_killProcess": "진저브레드 앱 프로세스 차단",
    "AUDIT_AppService_certificate": "인증",
    "DeviceResource_1001": "운영체제 종류",
    "LANG_deviceCount2": "단말개수",
    "DeviceResource_1000": "통신사",
    "DeviceResource_1003": "단말 제조사",
    "DeviceResource_1002": "운영체제 버전",
    "DeviceResource_1005": "CPU 종류",
    "LANG_Policy_ChooseLeftTree": "좌측 트리에서 정책을 선택하여 주세요.",
    "DeviceResource_1004": "단말 모델",
    "LANG_mar2": "3월",
    "MdmPolicyControlName_DisallowConvenienceLogon": "간편 로그온 비허용.",
    "jqGrid_delete": "삭제",
    "MdmPolicyControlName_AllowTelemetry": "Telemetry 허용.",
    "LANG_LOG_Statistics": "방문자관리",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_BUTTON_DETAIL": "비콘 위치 리스트 보기",
    "LANG_ALT_remoteCommand": "MDM 사용자의 단말을 관리자가 원격으로 제어합니다",
    "LANG_policyPublishToSaveDesc": "정책 저장",
    "MdmPolicyControlName_wirelessNetworkAuthorization": "무선 네트워크",
    "Title_000001700": "서기",
    "LANG_QrCode_Size_MIN": "최소 사이즈입니다.",
    "LANG_AP_DETAIL": "AP(Access Point) 상세보기",
    "SourceType_SERVER_SYSTEM": "시스템",
    "DeviceResource_1008": "USIM 일련번호",
    "DeviceResource_1009": "국가",
    "DeviceResource_1006": "Wi-Fi Mac Address",
    "DeviceResource_1007": "IMEI",
    "LANG_ApCondition": "무선 AP 조건",
    "ACTION_DeviceMDMService_sendResponse": "단말 원격 명령 결과 전송 통신",
    "ISSUE_SOLVE_ERROR_DBLimitWarning": "저장소의 허용용량 경고 제한 ���율에 도달하였습니다. 저장소 확보에 대한 조치를 하여야 합니다.",
    "AUDIT_DefenceSettingService_category": "구분",
    "AUDIT_LocationService_altitude": "고도",
    "LANG_createDateTime": "등록일시",
    "LANG_LocationPolicyNonApplyList": "미적용리스트",
    "PASSWORD_QUALITY_NUMERIC": "숫자포함",
    "AUDIT_UserDeviceService_pushId": "푸쉬아이디",
    "LANG_IssueCategory": "이슈분류",
    "LANG_other": "기타",
    "LANG_DEVICE_LostReport": "도난분실신고",
    "AUDIT_LocationService_address": "주소",
    "AUDIT_UserDeviceService_vendorPushEnabled": "벤더푸쉬여부",
    "Holiday": "공휴일",
    "Configuration_dbmsCriticalLimitsize_DESC": "허용용량 초과 제한 비율 설정합니다.(단위 : %, 기본값 : 90, 범위 : 90~95)",
    "LANG_APP_Name": "앱명",
    "AUDIT_LocationService_description": "설명",
    "LANG_SMS_Send_Failure": "SMS전송에 실패하였습니다.",
    "TermQuery": "조회",
    "LANG_ManageApps": "업무앱 관리",
    "MdmPolicyControlName_AllowAdvertising": "장치의 블루투스 광고 전송 허용여부.",
    "AUDIT_BeaconAreaService_description": "설명",
    "AUDIT_ProductDeviceService_osVersion": "OS 버전",
    "MdmPolicyControlName_AllowAddingNonMicrosoftAccountsManually": "MS 계정외의 계정 허용.",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT_IN": "비콘 입구 위치 선책",
    "AUDIT_ThirdPartyCompanyService_apiKey": "API KEY",
    "LANG_LocationPolicyPresentCondition": "출입정책 적용현황",
    "LANG_SETTING_DeptManagement": "조직관리",
    "LANG_policyTargetCnt": "대상 수",
    "LANG_LocationConditionDesc": "통신사 기지국(Cell ID)을 기반으로 출입정책조건을 설정합니다.",
    "MdmPolicyControlName_AllowSmartScreen": "스마트 스크린 허용.",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_IS_HOLIDAY": "휴일여부",
    "MdmPolicyControlName_useExternalSDCard": "외장 SDCARD 사용",
    "AL_UsbStorageLog": "USB 저장소 로그",
    "LANG_Self_Device_backup_device": "백업 실행",
    "ClientInstalled": "앱 설치여부",
    "WLAN_SCANMODE_DEFAULT": "기본",
    "AUDIT_NoticeTargetService_updateDate": "갱신시간",
    "IstalledDate": "설치날짜",
    "LANG_ManagerEdit": "관리자 수정",
    "execCommand": "실행명령",
    "Configuration_sessionMaxInactiveInterval_DESC": "관리 페이지의 세션 자동 종료 시간을 설정합니다. (단위: 초, 기본값 : 300)",
    "LANG_LOC_address": "주소",
    "LANG_LocationPolicyDeptPresentConditionNotUnderbar": "조직별 정책 현황",
    "AUDIT_LocationService_createDate": "생성시간",
    "Audit_DefenceSettingService": "설정>시스템설정",
    "LANG_LOC_radius": "반경",
    "AUDIT_AppService_installedAppVersion": "인스톨앱버전",
    "RC_RM_1": "중요 정보 삭제",
    "LANG_POLICY_PolicyConfigShort": "정책설정",
    "Configuration_maxSessionCnt_DESC": "동일 관리자 아이디로 관리 페이지 접속 가능한 세션 값을 설정합니다. (단위 : 명, 기본값 : 1)",
    "RC_RM_2": "앱 전체 삭제",
    "ERROR_AdminLocked": "사용자 지정된 암호 실패{0}로 잠금 상태가 되었습니다.",
    "LANG_Self_Desc_date_to_location": "최근 요청일시 : ",
    "LANG_ManageMain": "메인화면",
    "LANG_HolidayTitle": "휴일",
    "LANG_ManageAccessPoint": "무선 AP 관리",
    "LANG_DEVICE_TotalInfo": "단말종합정보",
    "MdmPolicyControlName_autoUpdateSec": "MDM 자동 업그레이드 시간",
    "AUDIT_AppService_installedApp": "인스톨여부",
    "LANG_sep2": "9월",
    "LANG_Office_Off_Policy": "오피스앱 OFF 정책",
    "LANG_LOG_AuditLog": "감사로그",
    "AL_AppsInfoOK": "단말에 설치된 어플 조회 성공",
    "AUDIT_LocationService_radius": "반경",
    "LANG_DEVICE_TotalStatus": "단말 종합 현황",
    "MESSAGE_ALERT_ONLY_SELECT_TARGET": "{0} 대상은 한개의 대상만 선택해 주십시오.",
    "LANG_DeviceRemoteCommand": "단말 원격 명령",
    "Configuration_dbmsWarnLimitsize": "DBMS SERVER 허용용량 경고 제한 비율",
    "CRITICALLOG": "위험 로그만 전송",
    "MdmPolicyControlName_userNotification": "사용자 알림",
    "LANG_NOTICE_NoticeManagementDetail": "단말 사용자에게 보낼 공지를 관리합니다.",
    "LANG_WP_federated_enrollment_item_email_address": "이메일주소",
    "AUDIT_VisitorUserService_externalVisitNo": "LDCC 방문자번호",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_SET": "시간설정",
    "LANG_ERROR_UserStatusIsNotUseUserMessage": "사용이 중지된 사용자 입니다.",
    "RC_OUTCALL_ON": "전화걸기 허용",
    "ERROR_ON_SENDING": "전송 실패",
    "conditionName": "조건명",
    "Configuration_adminAccessIP1_DESC": "허용 접속 IP 1 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "BLACKAPPHIDE": "숨기기",
    "MdmPolicyControlName_forceEnabledWiFi": "WiFi 사용 강제화",
    "APPCONTROLWHITE": "화이트앱",
    "MESSAGE_ALERT_NO_POLICY_ITEM": "정책항목이 설정되지 않았습니다.",
    "MdmPolicyControlName_AllowDeveloperUnlock": "개발자 해제 허용.",
    "MdmPolicyControlName_MDMRBS0000000001": "예약 백업",
    "MdmPolicyControlName_MDMRBS0000000002": "예약 백업 주기",
    "MdmPolicyControlName_MDMRBS0000000003": "예약 백업 일자",
    "PolicyControl_new_category_desc_3001": "단말기의 디바이스 장치를 제어하기 위한 정책을 설정합니다.",
    "MdmPolicyControlName_MDMRBS0000000005": "예약 백업 시간",
    "PolicyControl_new_category_desc_3002": "단말기의 응용 프로그램  통제 정책을 설정합니다.",
    "MdmPolicyControlName_MDMRBS0000000004": "예약 백업 요일",
    "PolicyControl_new_category_desc_3000": "iOS 단말기의 장치 관리를 위한 기본 정보를 설정합니다.",
    "LANG_ReservedVisitorManagementDetail": "예약된 방문자 목록을 관리합니다.",
    "AUDIT_UserService_lockCnt": "LOCK COUNT",
    "AUDIT_Pkcs12CertificateService_notBeforeDate": "인증서시작일자",
    "AUDIT_VisitorUserService_id": "아이디",
    "AUDIT_Pkcs12CertificateService_pkcs12Data": "PKCS12데이터",
    "AL_appRemove": "앱 삭제",
    "MdmPolicyControlName_allowSystemBrowser": "시스템 브라우저 차단 여부",
    "AUDIT_UserService_lock": "LOCK",
    "LANG_deviceCount": "설치된 단말개수",
    "LANG_PERSONNEL_ReservedVisitorManagement": "방문자예약관리",
    "PolicyControl_new_category_desc_3004": "Safari 의 통제 정책을 설정합니다.",
    "PolicyControl_new_category_desc_3003": "iCloud 를 통한 클라우드 서비스 통제 정책을 설정합니다.",
    "TargetCompany": "회사",
    "AUDIT_ReservedVisitorService_employeeComapny": "방문자직원회사",
    "PolicyControl_new_category_desc_3005": "단말기의 보안을 위한 암호 정책을 설정합니다.",
    "AUDIT_HolidaysService_name": "명칭",
    "LANG_QrCode_Size_MAX": "최대 사이즈입니다.",
    "LANG_ApConditionDesc": "WIFI AP(Access Point)를 기반으로 출입정책조건을 설정합니다.",
    "devcieBasicInfo": "단말 기본 정보",
    "AUDIT_UserService_isUse": "사용여부",
    "MESSAGE_ALERT_NO_REMOTE_HISTORY": "원격 명령 이력이 존재 하지 않습니다.",
    "AUDIT_LocationService_id": "ID",
    "Label_LastPolicyApplied": "적용 정책",
    "MESSAGE_ALERT_LOST_REQUIRED": "분실 신고/긴급 메시지 전송시 {0} 입력은 필수입니다.",
    "AUDIT_ProductDeviceService_vendorName": "벤더명",
    "LANG_SMS_Confirm": "SMS전송 이력이 있습니다. 다시 보내시겠습니까?",
    "LANG_IsRooted": "루팅 현황",
    "MESSAGE_ALERT_NO_DIVICE_LOCATION": "단말기 위치 정보가 존재 하지 않습니다.",
    "MdmPolicyControlName_AllowWiFi": "WiFi 허용.",
    "LANG_isRegistered": "등록됨",
    "BSID": "BSID",
    "RC_UNENROLLMENT_MDM": "단말 MDM 해제",
    "MdmPolicyControlName_DevicePasswordEnabled": "장치 비밀번호 필수여부.",
    "PasswordPolicyNumber": "숫자",
    "LANG_LOC_locationid": "위치명",
    "AUDIT_ReservedVisitorService_employeePosition": "방문부서담당자직책",
    "RC_INIT": "명령대기",
    "ISSUE_SOLVE_SamsungSDK": "삼성 단말기에 삼성 SDK 로 서명하지 않은 MDM앱이 설치되었습니다. 삼성 SDK로 서명한 MDM앱을 배포하여 주십시오.",
    "LANG_DeviceStatus": "단말현황",
    "MdmPolicyControlName_allowCamera": "카메라 사용 허용",
    "LANG_OS": "OS 별",
    "UserDepartmentChange": "사용자 부서 변경",
    "AddAccessPoint": "무선AP추가",
    "LANG_WP_federated_enrollment_item_confirm_button": "확인",
    "MdmPolicyControlName_AllowBluetooth": "블루투스 허용.",
    "AUDIT_VersionedAppService_category": "앱구분",
    "SourceType_EXT_API_CALL": "API 호출",
    "AUDIT_NoticeService_statusCode": "상태코드",
    "BUTTON_SAVE_SETTING": "설정저장",
    "RC_GET_ALL_APPS": "설치된 앱 조회",
    "LANG_Policy_select_all": "전체선택",
    "LANG_targetType": "대상 종류",
    "AUDIT_UserService_roleType": "권한 타입",
    "LANG_sun": "일",
    "LANG_POLICY_NAME": "정책별",
    "LANG_APP_agentIsInstalled": "에이전트 앱 설치여부",
    "LANG_TOP_DeviceManagement": "단말기관리",
    "PasswordConfirm": "패스워드 확인",
    "LANG_LOC_longitude": "경도",
    "RC_ERROR_ON_EXECUTING": "명령실행실패",
    "MdmPolicyControlName_AllowPrepairing": "호스트 장치로 주변 특정 번들 블루투스를 자동 페어 처리여부.",
    "LANG_REMOTE_LOST_CLEAR": "분실 / 도난 신고를 해제하시겠습니까? ",
    "LANG_Search2": "건이 검색되었습니다.",
    "LANG_Search1": "총",
    "LANG_Search4": "총 0 건이 검색되었습니다.",
    "LANG_DEVICE_RemoteManagement": "원격관리",
    "LANG_Search3": "건",
    "LANG_LOGIN_MAX_OVER_ERROR": "동일계정/권한의 관리자가 접속하여 본 접속을 종료합니다.",
    "LANG_APP_UserAppState": "사용자앱 설치현황",
    "AUDIT_UserService_company": "업체",
    "AL_TAToken_ISSUE": "인증 토큰 발급",
    "LANG_DEVICE_LostReportShort": "도난분실신고",
    "EditProductDevice": "단말유형 수정",
    "MdmPolicyControlName_allowManagedAppsCloudSync": "앱 동기화 허용",
    "LANG_Windows_Auto_Update04": "유저의 확인없이 자동설치후 자동 재시작.",
    "LANG_Windows_Auto_Update05": "자동 업데이트 OFF.",
    "AUDIT_HolidaysService_updateDate": "갱신시간",
    "LANG_DeviceRemoteManageDetail": "MDM 사용자의 단말을 관리자가 원격으로 제어합니다.",
    "LANG_Windows_Auto_Update01": "자동 설치 업데이트.",
    "LANG_Windows_Auto_Update00": "유저에게 알람.",
    "RC_LOCK_ON": "단말 시스템 잠금 (Android)",
    "LANG_CATEGORY_DEVICE": "단말종합현황",
    "LANG_Windows_Auto_Update03": "특정 시간대에 자동 설치후 자동 재시작.",
    "GeneralLoginError": "아이디나 암호가 잘못되었습니다. 다시 입력해 주세요.",
    "LANG_Windows_Auto_Update02": "자동 설치 업데이트 후 자동 재시작.",
    "MdmPolicyControlName_ScheduledInstallDay": "IT 관리자가  업데이트 설치의 설치날짜 가능 일.",
    "LANG_APP_FileName": "앱파일명",
    "AL_restoreFail": "복구 실패",
    "ManagePolicyCondition": "정책관리",
    "SourceType_DEVICE": "단말",
    "selectTargetNotice": "대상선택",
    "LANG_ERROR_ReachedMaxSessionCount": "최대 로그인 가능한 세션을 초과하였습니다.",
    "LANG_APP_BlackAppManagement": "블랙앱관리",
    "LANG_DefaultPolicyInfo": "정책 기본 정보",
    "AUDIT_ControlAPService_auth": "인증",
    "LANG_POLICY_ResetFactoryDefaults": "공장초기화",
    "AUDIT_ProductDeviceService_id": "ID",
    "LANG_REMOTE_DEVICE_EXPLANATION": "분실된 단말기의 기능제어를 할 수 있습니다. 원하시는 기능을 선택하시고 실행버튼을 누르십시오.",
    "LANG_NoData_remoteCmdList": "원격 명령 이력이 존재 하지 않습니다.",
    "policyPublishSuccessful": "성공적으로 정책을 저장하고 배포중에 있습니다.",
    "LANG_Policy_ChooseTopPolicy": "상위 정책을 선택하여 주세요.",
    "LANG_List": "목록",
    "MESSAGE_ALERT_CONFIRM_SAVE": "저장하시겠습니까?",
    "LANG_Self_Device_status": "디바이스 상태",
    "BUTTON_OK": "확인",
    "MdmPolicyControlName_AllowAllTrustedApps": "스토어에서 포함되지 않은앱 허용.",
    "Status_OPENED": "발생",
    "LANG_LostTotal": "총 분실 건수",
    "NOTNOW": "단말수행대기",
    "AUDIT_ProductDeviceService_status": "상태",
    "MdmPolicyControlName_allowInAppPurchases": "앱 내 구입 허용",
    "LANG_LogOut": "로그아웃",
    "BUTTON_DELETE": "삭제",
    "Audit_VersionedAppService": "단말기관리>앱관리",
    "LANG_DEVICE_device": "단말기",
    "LANG_LOC_searchCountIs": "단말 사용자가 이동한 경로에 대한 개수(예. 10개 - 10개의 이동 경로를 표시합니다)",
    "LANG_Normal": "정상",
    "LANG_PERSONNEL_VisitorManagementLatest": "최근 방문자",
    "MdmPolicyControlName_forceC2dm": "GCM(구 C2DM) 사용 강제",
    "LANG_SearchResultTotal": "총 {0} 건이 검색되었습니다.",
    "LANG_dec2": "12월",
    "LANG_APP_publishTargetInfo": "앱 배포 적용 대상",
    "AUDIT_ReservedVisitorService_employeeDeptName": "직원부서이름",
    "LANG_ManageCheck": "체크",
    "LANG_Self_Desc_location_to_device": "요청한 기능은 네트워크 환경 및 디바이스의 상태에 따라 오래 걸리거나 실패할 수도 있습니다.<br>기능을 실행하면 실행내역이 디바이스에 전달됩니다.",
    "LostStatus": "분실상태",
    "LANG_osType": "OS타입",
    "LANG_VendorName": "제조판매사",
    "MESSAGE_ALERT_CONFIRM_DELETE": "삭제하시겠습니까?",
    "LANG_INITPW_INIT_INFORMATION_MESSAGE": "● 최초 로그인 시 비밀번호 변경이 필요합니다.",
    "MdmPolicyControlName_MaxiumLog": "최대 로그 개수",
    "LANG_EXECUTION_SUCCEEDED": "푸쉬 실행 성공. ",
    "AUDIT_UserDeviceService_reConnectCount": "재접속횟수",
    "Audit_BeaconAreaService": "정책관리>정책자원관리>비콘위치관리",
    "AUDIT_LocationService_latitude": "위도",
    "ajaxErrMsg": "ajax 통신 에러.\n다시 시도해 주십시오.",
    "LANG_NUMERIC_ENG_CHECK": "[{0}] 은/는 영문/숫자만 입력 가능합니다.",
    "LANG_Rooted": "루팅됨",
    "codeGroup": "코드그룹",
    "LANG_POLICY_CONDITION_BIZ_APP": "업무앱",
    "LANG_Self_Device_lock_status": "잠금여부",
    "LANG_USER_DELETE_FAILED": "삭제에 실패하였습니다. MDM을 사용하는 사용자가 존재합니다.",
    "AL_policyAppsApplyOK": "앱 정책 적용 성공",
    "AUDIT_ProductDeviceService_updateDate": "갱신시간",
    "LANG_POLICY_condition": "정책 조건",
    "LANG_LocationManagement": "위치관리",
    "AUDIT_UserService_email": "이메일",
    "LANG_LOG_DeviceStatusByGroup": "조직별 단말현황",
    "AL_TAToken_Expired": "인증 토큰 만료",
    "AL_adminAcquire": "장치 관리자 등록",
    "LANG_LOC_remoteCommandListDetail": "선택하신 단말에서 실행한 원격 명령 이력을 조회하실 수 있습니다.",
    "MdmPolicyControlName_AllowManualRootCertificateInstallation": "최상위 인증서 수동설치 허용.",
    "Configuration_encodeDvc": "DVC 인코딩 여부",
    "LANG_UserName": "사용자명",
    "LANG_LocationPolicyDeptPresentCondition": "조직별_정책_현황",
    "AUDIT_UserDeviceService_lockDevice": "잠금디바이스",
    "MdmPolicyControlName_AllowIdleReturnWithoutPassword": "비밀번호 없이 화면 유지 허용.",
    "SSID": "SSID",
    "Label_LastAccessDate": "마지막 접속 시간",
    "LANG_ReservedVisitorManagement_KAI_company": "소속회사",
    "EditVarification": "앱 검증로그 수정",
    "LANG_APP_NoneAppAdd": "기타앱 추가",
    "LANG_NoRoot": "정상",
    "policyDesc": "정책설명",
    "policyControlClassList": "추가할 수 있는 MDM기능 항목",
    "LANG_day17": "17일",
    "LANG_day16": "16일",
    "LANG_day19": "19일",
    "fileNotFound": "{0} 파일을 찾을 수 없습니다.",
    "LANG_TargetDeptName": "부서",
    "LANG_day18": "18일",
    "LANG_day10": "10일",
    "LANG_day11": "11일",
    "LANG_day12": "12일",
    "LANG_SMS_Send": "SMS을 전송하시겠습니까?",
    "LANG_day13": "13일",
    "LostUser": "사용자",
    "Configuration_deviceMaximumInactiveTime": "단말 최대 접속 확인 시간",
    "LANG_day14": "14일",
    "LANG_ManageApplication": "적용",
    "LANG_day15": "15일",
    "cteateDateTime": "등록일",
    "LANG_Windows_Bluetooth00": "비허용.",
    "LANG_Windows_Bluetooth01": "보류.",
    "LANG_Valid_UUID_MSG": "위치 UUID 입력값이 유효하지 않습니다",
    "LANG_Windows_Bluetooth02": "허용.",
    "BUTTON_REMOTE": "원격조회",
    "MdmPolicyControlName_c2dmUse": "GCM(구 C2DM) 사용",
    "SAFARIACCEPTCOOKIES_NO_USE": "사용안함",
    "LANG_day08": "08일",
    "LANG_day07": "07일",
    "LANG_day06": "06일",
    "AUDIT_AppService_installedDate": "인스톨일자",
    "LANG_day05": "05일",
    "LANG_day09": "09일",
    "LANG_day03": "03일",
    "LANG_day04": "04일",
    "LANG_day01": "01일",
    "Status_PASSIVE": "비활성",
    "LANG_day02": "02일",
    "AUDIT_ThirdPartyDeptService_typeCode": "TYPE CODE",
    "LANG_Policy_Not_SubjectPolicy": "정책을 적용할 대상이 없습니다.",
    "AUDIT_VersionedAppService_allowedUse": "사용허용여부",
    "NoticeTargetType": "공지대상",
    "LANG_mar": "3월",
    "LostDept": "부서",
    "LANG_APP_notInstalled": "미설치",
    "ALLOW_TELEMETRY_RESTRICT": "제한적허용",
    "LANG_Weekly": "주간별",
    "Severity_FATAL": "심각",
    "Configuration_passwordMinLength_DESC": "관리자/사용자 패스워드 최소 길이를 설정합니다. (단위 : 자리, 기본값 : 9)",
    "LANG_day30": "30일",
    "AUDIT_ProductDeviceService_osType": "OS 구분",
    "LANG_day31": "31일",
    "MdmPolicyControlName_allowSharedStream": "공유사진 스트림 허용",
    "LANG_IsLostIng": "도난/분실 처리중",
    "LANG_may": "5월",
    "LANG_SETTING_UserAgreementManagement": "사전동의정보관리",
    "AUDIT_BeaconAreaService_id": "ID",
    "LANG_LostStatus": "도난분실현황",
    "LANG_USER_Init": "사용자 초기화",
    "LANG_Windows_Auto_Update_Day01": "일요일.",
    "LANG_Windows_Auto_Update_Day02": "월요일.",
    "LANG_Windows_Auto_Update_Day00": "매일.",
    "LANG_Windows_Auto_Update_Day05": "목요일.",
    "LANG_day29": "29일",
    "LANG_LOC_altitude": "고도",
    "AUDIT_NoticeTargetService_name": "명칭",
    "LANG_Windows_Auto_Update_Day06": "금요일.",
    "LANG_day28": "28일",
    "LANG_Windows_Auto_Update_Day03": "화요일.",
    "LANG_day27": "27일",
    "AUDIT_ThirdPartyDeptService_id": "ID",
    "LANG_Windows_Auto_Update_Day04": "수요일.",
    "LANG_day25": "25일",
    "Name": "이름",
    "LANG_day26": "26일",
    "LANG_day23": "23일",
    "LANG_day24": "24일",
    "LANG_Windows_Auto_Update_Day07": "토요일.",
    "LANG_day21": "21일",
    "LANG_day22": "22일",
    "LANG_day20": "20일",
    "LANG_LOG_InstallLog": "단말설치현황",
    "LANG_APP_PreviousVersion": "이전",
    "AUDIT_ProductDeviceService_name": "명칭",
    "WARNLOG": "경고 및 위험 로그만 전송",
    "ManageLog": "로그관리",
    "LANG_Office_On_Policy": "오피스앱 ON 정책",
    "AUDIT_NoticeService_creator": "생성자",
    "MdmPolicyControlName_safariAllowAutoFill": "자동 완성 활성화",
    "ServiceURL": "서비스 URL",
    "ADPR_USER": "사용자선택",
    "RetrieveUser": "사용자 조회",
    "LANG_deptName": "부서",
    "LANG_ManageBeaconArea": "비콘 위치 관리",
    "LANG_WP_federated_enrollment_ERROR_UserNotUse": "사용자가 비활성상태입니다. 시스템 관리자에게 문의하여 주세요.",
    "EVERYWEEK": "매주",
    "AUDIT_UserDeviceService_createDate": "생성시간",
    "ACTION_ApplicationStopped": "보안시스템 / 감사로그 종료",
    "InstallClientDate": "설치일시",
    "LANG_latelyLog_Graph_Comment": "지금으로 부터 단위 전까지의 데이터입니다.",
    "MdmPolicyControlName_AllowSaveAsOfOfficeFiles": "오피스 파일 저장 허용.",
    "Email": "이메일",
    "AUDIT_BeaconAreaService_area": "위치",
    "AUDIT_ReservedVisitorService_visitor": "방문객",
    "AUDIT_UserTitleService_id": "ID",
    "LANG_LOG_IssueLogDetail": "주요 보안이슈에 대한 처리내역 로그를 조회합니다.",
    "LANG_SpeedGateConditionDesc": "출입시스템(Speed Gate) 연동 여부를 설정합니다. (기 구축된 출입시스템-Speed Gate이 있는경우)",
    "MdmPolicyControlName_AllowStorageCard": "저장소 허용.",
    "AddVarification": "앱 검증로그 추가",
    "MdmPolicyControlName_EnableDeleteButton": "삭제버튼 활성화  ",
    "EditCertificate": "인증서 변경",
    "MdmPolicyControlName_AllowSharingOfOfficeFiles": "오피스 파일 공유허용.",
    "LANG_plzSelctRows": "행을 선택하세요.",
    "MDMx9001": "[ {0} ] 은(는) 필수입력 값 입니다.",
    "LANG_MemberNum": "사번",
    "ApiKey": "API 키",
    "LANG_LastAccessTime": "접속 시간",
    "MdmPolicyControlName_AllowDoNotTrack": "트랙해더의 허용.",
    "LANG_Monthly": "월별",
    "LANG_ManagePolicy": "정책 관리",
    "LABEL_lastBackupTime": "최종 백업일시",
    "Audit_ProductDeviceService": "설정>단말유형설정",
    "LANG_logType": "로그타입",
    "MdmPolicyControlName_wifiApDailyReset": "WiFi AP정보 일일 초기화",
    "jqGrid_add": "추가",
    "AddConfiguration": "설정 추가",
    "MdmPolicyControlName_encOutMemory": "외장 메모리 암호화",
    "ACTION_DeviceService_unregisterDevice": "단말 해제 통신",
    "LANG_POLICY_CONDITION_TITLE_TYPE_WIFI_AP_SELECT": "Wi-Fi AP 선택",
    "AUDIT_UserService_accountNonExpired": "ACCOUNT NON EXPIRED",
    "LANG_PERSONNEL_VisitorManagement": "방문자관리",
    "ISSUE_SOLVE_ERROR_UserNotUse": "사용이 제한된 사용자 입니다. \"사용자 관리\"->\"사용자 관리\" 에서 \"사용여부\" 를 확인 하십시오.",
    "LANG_USR_user": "사용자",
    "LANG_LocationPolicyTotalcount": "출입정책별 수",
    "Operation_UPDATE": "수정 완료",
    "LANG_Policy_was_Registered": "이미 등록된 대상입니다.",
    "DuplicateUsername": "사용자 아이디가 중복입니다.",
    "InvalidIp": "IP가 올바르지 않습니다.",
    "CompanyViewPopup": "등록업체 상세정보 보기",
    "LANG_ErrorLogin": "아이디 또는 패스워드가 잘못되었습니다.",
    "AllowedIP_Question": "허용접속IP 이란?",
    "managerContact": "발신 번호",
    "LANG_xisCompleted": "{0} 완료되었습니다.",
    "LANG_USR_ConfigDetail": "MDM사용자에 대한 정보를 관리합니다.",
    "AddCertificate": "인증서 추가",
    "Configuration_passwordCombine_DESC": "관리자/사용자 패스워드 유형을 설정합니다. (기본값 : 숫자 + 영문자 +특수문자)",
    "Label_AdditionalUserGuideMessage": "사용자에게 추가로 보낼 메세지",
    "MdmPolicyControlName_AllowSearchToUseLocation": "유저 위치 검색 허용.",
    "LANG_POLICY_TRANSFER_ING": "정책 전송 중",
    "AUDIT_BeaconAreaService_minorDc": "minorDC",
    "LANG_ManageAccessPointDetail": "무선AP관리란? MDM정책이 실행되는 무선 네트워크 정보를 관리합니다.",
    "LANG_jan2": "1월",
    "Title_Assistant": "대리",
    "AUDIT_PassingStatusService_signalStatus": "상태",
    "LANG_POLICY_PolicyApplyStatus": "정책적용현황",
    "AUDIT_VisitorUserService_scheduledTime": "스케쥴시간",
    "LANG_ManageNotice": "공지 관리",
    "LANG_REMOTE_LOST_EXPLANATION2": "입력하신 후 [도난/분실 신고] 버튼을 누르시기 바랍니다.",
    "AUDIT_PassingStatusService_category": "구분",
    "AUDIT_BeaconAreaService_minor": "minor",
    "LANG_REMOTE_LOST_EXPLANATION3": "분실 / 도난 버튼을 클릭해 주세요",
    "LANG_REMOTE_LOST_EXPLANATION1": "분실 / 도난 시 연락받을 수 있는 전화번호와 단말기 습득자에게 전할수 있는 메시지를",
    "LANG_POLICY_PolicySchedule_Desc": "정책 전송을 예약 합니다.",
    "AUDIT_VisitorUserService_name": "이름",
    "LANG_logDateTime": "조회일시",
    "LANG_nov2": "11월",
    "PolicyControl_new_category_desc_4002": "위치정보의 관리 정책을 설정합니다.",
    "PolicyControl_new_category_desc_4001": "에이전트의 관리 정책을 설정합니다.",
    "PolicyControl_new_category_desc_4000": "단말 로그의  관리 정책을 설정합니다.",
    "MdmPolicyControlName_AllowMicrosoftAccountConnection": "MS 계정 접속 허용.",
    "ERROR_UserNotUse": "사용자의 상태가 제한되어 있습니다.",
    "LANG_APP_isLatest": "최신 버전 여부",
    "MdmPolicyControlName_AllowCamera": "카메라 허용.",
	"MdmPolicyControlName_forceAssistantProfanityFilter": "Siri 제안 허용",
	"MdmPolicyControlName_allowCloudCalendar": "사진 동기화 허용",
	"MdmPolicyControlName_allowFingerprintForUnlock": "생채 인식 잠금 해제 허용",
	"MdmPolicyControlName_allowChat": "메신저 허용",
	"MdmPolicyControlName_allowAutomaticAppDownloads": "앱 자동 다온로드 허용",
	"MdmPolicyControlName_allowFilesUSBDriveAccess": "USB 드라이브 접근 허용",
	"MdmPolicyControlName_allowFilesNetworkDriveAccess": "네트워크 드라이브 접근 허용",
	"MdmPolicyControlName_allowEraseContentAndSettings": "초기화 허용",
	"MdmPolicyControlName_allowVPNCreation": "VPN 구성 추가 허용",
	"MdmPolicyControlName_allowAccountModification": "계정 설정 수정 허용",
	"MdmPolicyControlName_allowBluetoothModification": "블루투스 수정 허용",
	"MdmPolicyControlName_allowAppCellularDataModification": "Celluar 데이터 설정 수정 허용",
	"MdmPolicyControlName_allowDeviceNameModification":"기기 이름 수정 허용",
	"MdmPolicyControlName_allowNotificationsModification": "알림 설정 수정 허용",
	"MdmPolicyControlName_allowPersonalHotspotModification": "개인용 핫스팟 설정 변경 허용",
	"MdmPolicyControlName_allowUSBRestrictedMode": "USB 연결 허용",
	"MdmPolicyControlName_allowPasswordAutoFill": "암호 자동 완성 허용",
	"MdmPolicyControlName_allowPasswordProximityRequests": "암호 공유 요청 허용",
	"MdmPolicyControlName_allowPasswordSharing": "암호 공유 허용",
	"MdmPolicyControlName_allowAirPrint": "AirPrint 허용",
    "Configuration_reConnectDeviceMaximum_DESC": "단말기에 에이전트 재설치 회수를 설정합니다. (단위 : 회, 기본값: 5, 범위 : 1~5)",
	"MdmPolicyControlName_allowPairedWatch": "Watch 페어링 허용",
	"MdmPolicyControlName_blacklistedAppBundleIDs": "블랙리스트 앱 차단",
	"MdmPolicyControlName_whitelistedAppBundleIDs": "화이트리스트 앱 허용",
    "LANG_ManagerID": "관리자 아이디",
    "AppPlatform": "앱 플랫폼",
    "AUDIT_UserService_credentialsNonExpired": "CREDENTIALS NON EXPIRED",
    "ADPR_N": "숫자",
    "AUDIT_UserService_permAccessIp1": "접속허용IP1",
    "AUDIT_UserService_permAccessIp2": "접속허용IP2",
    "LANG_Valid_UUID_FAIL_MSG": "비콘의 UUID, Major, Minor 값이 중복됩니다.",
    "LANG_LENGTH_CHECK": "[{0}] 은/는 {1}자 이하로 입력을 제한합니다.",
    "MdmPolicyControlName_allowVideoConferencing": "FaceTime 허용",
    "ACTION_MdmLogController_setFixed": "보안 이슈 해결",
    "jqGrid_alert": "경고",
    "LoginTitle": "앱 디펜스 관리 콘솔 로그인",
    "LANG_ManageHoliday": "휴일 관리",
    "MdmPolicyControlName_screenPowerSavingMode": "화면 절전 모드",
    "Title_Manager": "과장",
    "deviceRemoteCommand": "단말 원격 제어",
    "LANG_Already_registered_bwApp": "Black/White App으로 이미 등록된 App 입니다.",
    "AUDIT_UserDeviceService_lostTime": "분실시간",
    "AUDIT_NoticeTargetService_targetType": "대상타입",
    "AUDIT_UserDeviceService_rooted": "루팅여부",
    "LANG_LOG_SecurityIssueLatest": "최근보안이슈",
    "RC_BACKUP": "백업",
    "LANG_POLICY_CONDITION_GPS": "GPS기반",
    "LANG_LostNot": "정상사용",
    "LANG_POLICY_resetPassword": "단말패스워드 초기화",
    "MdmPolicyControlName_heartBeatPeriod": "Heart Beat 주기",
    "Title_000001600": "선임사무원",
    "Title_000001601": "주임사무원",
    "LANG_Self_Device_lost_status": "분실여부",
    "LANG_ManagerAdd": "관리자 추가",
    "ISSUE_SOLVE_AL_policyApplyFail": "단말에서 정책 적용이 실패되었습니다. 단말기를 조사하여 해당 문제를 해결하여야 합니다.",
    "osType": "OS타입",
    "LANG_whole": "전체",
    "MdmPolicyControlName_RestrictAppDataToSystemVolume": "어플리케이션의 데이터가 시스템 드라이버에 제한허용.",
    "LANG_POLICY_CertificationManagementDetail": "화이트앱관리를 위한 앱에 대한 인증서를 관리합니다.",
    "AUDIT_UserService_enabled": "ENABLED",
    "LANG_DeviceInfo": "단말기본정보",
    "MdmPolicyControlName_AllowPasswordManager": "장치에서 비밀번호의 저장과 관리의 허용.",
    "Audit_MdmPolicyService": "정책관리>정책설정",
    "LANG_APP_BlackAppSelection": "블랙앱 지정",
    "LANG_SETTING_DeptManagementDetail": "MDM사용자의 조직 및 부서를 관리합니다.",
    "AlertSelectDept": "상위부서 변경할 부서를 먼저 선택하십시오.",
    "LANG_Notice": "공지사항",
    "LANG_Lock": "잠김",
    "IpPattern": "IP 패턴",
    "LANG_Self_Device_loss_device": "단말 도난 분실 신고",
    "LANG_USR_Config": "사용자 설정",
    "LANG_Weekly2": "주별",
    "LANG_NOTICE_UserAgreementManagementDetail": "단말 등록 시 사용자에게 고지되는 사전동의 정보를 관리합니다.",
    "LANG_SystemManagement": "시스템 관리",
    "LANG_Detail": "자세히",
    "DetailColumn": "상세정보보기",
    "AlertSelectUser": "부서변경할 사용자를 먼저 선택하십시오.",
    "LANG_APP_WhiteAppManagement": "화이트앱관리",
    "LANG_LOG_Lateset": "최근 로그",
    "AL_OfficeAppOff": "업무앱 Off",
    "LANG_beaconArea_ADD": "비콘 위치정보 추가",
    "InstallDate": "설치일",
    "LANG_POLICY_CONDITION_NAME": "정책조건명",
    "LANG_POLICY_CONDITION_TITLE_TYPE_NAME": "정책조건명 입력",
    "LANG_POLICY_HolidayManagement": "휴일 관리",
    "LANG_policyTargetTitleDetail": "MDM정책에 대한 적용 대상을 선택합니다.",
    "LANG_ALT_whteappManagement": "단말 사용자가 설치한 앱을 허가된 앱으로 승인합니다.",
    "ISSUE_SOLVE_DeviceManagerDisabled": "해당 단말이 기기관리자를 활성화 하지 않았습니다. 사용자에게 기기관리자 활성화를 가이드할 메세지를 보내도록 합니다.",
    "APPin": "PIN",
    "LANG_latestSendDate": "마지막전송일시",
    "AUDIT_UserDeviceService_agentId": "단말아이디",
    "LANG_POLICY_List": "정책리스트",
    "LANG_APP_PresentCondition": "앱 현황",
    "ERROR_AuthenticationFailed": "인증에 실패하였습니다. 인증정보를 확인하고 다시 시도해 주십시오.",
    "PermAccessIp1": "허용접속IP1",
    "MdmPolicyControlName_AllowAutoConnectToWiFiSenseHotspots": "WiFi 핫스팟 자동 접속허용여부.",
    "PermAccessIp2": "허용접속IP2",
    "LANG_ALT_lost": "도난 및 분실된 단말을 관리합니다.",
    "BUTTON_PUBLISH": "배포",
    "AUDIT_ProductDeviceService_modelName": "모델명",
    "MdmPolicyControlName_isAutoTime": "자동 시간 동기화",
    "RC_WIFI_SET": "WiFi AP 정보 초기화",
    "AUDIT_VisitorUserService_position": "직위",
    "AL_backupFail": "백업 실패",
    "AUDIT_PassingStatusService_updateDate": "갱신시간",
    "AUDIT_ReservedVisitorService_updateDate": "갱신시간",
    "LANG_SearchToLike": "포함",
    "MdmPolicyControlName_maxGracePeriod": "단말 잠금 유예 최대 기간 (분)",
    "ChildDeptName": "하위부서",
    "ERROR_DeviceIsNotSupported": "지원되지 않는 장치 모델({0})이 등록을 시도하였습니다.",
    "LANG_QrPolicy": "QR 정책",
    "LANG_sourceIp": "대상IP",
    "AUDIT_UserDeviceService_authToken": "인증토큰",
    "LANG_POLICY_CONDITION_TITLE_TYPE_WIFI_AP_BUTTON_DETAIL": "Wi-Fi AP 리스트 보기",
    "MdmPolicyControlName_AllowSyncMySettings": "유저 계정설정정보 동기화 허용.",
    "AUDIT_VersionedAppService_aliasGroup": "별칭 사용",
    "AUDIT_NoticeTargetService_id": "ID",
    "BUTTON_MODIFY": "수정",
    "deviceInstallHistory": "설치이력",
    "LANG_LOG_InstallLogListDetail": "각 목록명을 누르시면 목록별 정렬을 하실 수 있습니다.",
    "LANG_IsUse": "사용여부",
    "LANG_INITPW_ITEM_PASSWORD_1MORE": "새 비밀번호 확인",
    "Title_000001181": "차석검사원",
    "Title_000001182": "팀장",
    "Title_000001180": "차석행정원",
    "BUTTON_RUN": "실행",
    "Title_000001185": "책임행정원",
    "Title_000001186": "책임검사원",
    "Title_000001183": "파트장",
    "Title_000001184": "과장",
    "Severity_VERBOSE": "상세",
    "Title_000001189": "선임행정원",
    "BUTTON_FREE": "해제",
    "Title_000001187": "계장",
    "Title_000001188": "주임",
    "AUDIT_LocationService_cellId": "셀ID",
    "targetType": "대상 종류",
    "NoticeEndDate": "공지종료일",
    "LANG_ManageDept": "부서 관리",
    "LANG_POLICY_listDetail": "선택된 정책조건에 적용되어 있는 기능항목을 확인합니다.",
    "AUDIT_ThirdPartyCompanyService_name": "명칭",
    "AUDIT_AppService_appAgent": "MDM여부",
    "LANG_Validation_alert_searchDate_required": "시작일과 종료일은 필수 입력 값입니다.",
    "Title_000001190": "사무국장",
    "Title_000001191": "대리",
    "Title_000001192": "선임검사원",
    "Title_000001193": "주임행정원",
    "Configuration_passwordChangePeriod_DESC": "관리자/사용자 비밀번호 변경주기를 설정합니다.(단위 : 개월, 기본값 : 3)",
    "Title_000001194": "주임검사원",
    "Title_000001195": "행정원",
    "Title_000001196": "검사원",
    "Title_000001197": "계약직",
    "Title_000001198": "담당",
    "Title_000001199": "팀원",
    "AUDIT_AppService_createDate": "생성시간",
    "ACTION_DeviceManagerDisabled": "장치 관리자 권한 비활성",
    "Severity_INFO": "정보",
    "changeDeptTitle": "상위부서 선택/변경",
    "LANG_SearchToNone": "미포함",
    "RoleSecurityManager": "보안관리자",
    "LANG_AdminID": "관리자 아이디",
    "AUDIT_ProductDeviceService_createDate": "생성시간",
    "LANG_POLICY_selectedTargetDetail": "선택된 대상에 적용된 정책내용 입니다.",
    "AUDIT_ReservedVisitorService_visitType": "방문타입",
    "LANG_POLICY_ApplyTarget": "적용대상",
    "LANG_SearchToDesc": "검색조건의 문자를 포함하는지 문자열로 검색하는지의 여부입니다.",
    "ALLOW_TELEMETRY_NOT": "허용안함",
    "BUTTON_REFRESH": "새로고침",
    "Title_General": "부장",
    "AUDIT_UserDeviceService_unRegisteredDate": "미등록일자",
    "MdmPolicyControlName_whetherToAdjustTheBrightness": "밝기조정 여부",
    "LANG_Configuration": "설정",
    "AUDIT_ReservedVisitorService_deptName": "방문부서명",
    "LANG_ExcelImport": "엑셀로 등록",
    "AL_ProfileDeleteToNormal": "단말 프로파일 삭제",
    "policyName": "정책명",
    "MdmPolicyControlName_AllowCopyPaste": "복사/붙여넣기 허용여부.",
    "MdmPolicyControlName_AllowStoringImagesFromVisionSearch": "비전 검색으로부터 이미지 스토링 허용.",
    "LANG_LOC_managementIs": "위치관리란? MDM정책이 실행되는 위치 정보를 관리합니다.",
    "AL_USIMStatus": "USIM 카드 상태",
    "MdmPolicyControlName_AllowDiscoverableMode": "블루투스 가능 장치가 해당 장치의 검색허용여부.",
    "AUDIT_VisitorUserService_updateDate": "업데이트날짜",
    "LANG_POLICY_CONDITION_INOUTSYSTEM": "출입시스템",
    "LANG_PropertyName": "설정명",
    "LANG_POLICY_COMMENT_DeploymentPolicy1": "정책을 추가 및 수정하신 후 상하단에 위치한",
    "LANG_NOTICE_Send": "공지전송",
    "LANG_POLICY_COMMENT_DeploymentPolicy2": "정책 배포하기를 클릭",
    "AUDIT_DefenceSettingService_name": "명칭",
    "IsRegistered": "단말등록여부",
    "LANG_PropertyValue": "설정값",
    "LANG_TotalSum": "총합계",
    "LANG_CATEGORY_APP": "앱 관리",
    "EditHoliday": "휴일 수정",
    "AUDIT_VisitorUserService_deptName": "부서이름",
    "AUDIT_ReservedVisitorService_scheduledTime": "스케쥴시간",
    "LANG_SpeedGate": "출입시스템 연동",
    "MdmPolicyControlName_AllowManualWiFiConfiguration": "WiFi 수동설정여부.",
    "LANG_msgModify": "수정",
    "ViewNotice": "공지 보기",
    "AddApp": "앱 추가",
    "LANG_WARNING_LEVEL3_MSG": "FATAL Level : 심각한 오류에 대한 로그",
    "LANG_Validation_alert_input": "[{0}] 은/는 검증에 실패하였습니다.",
    "AL_adminLost": "장치 관리자 해제",
    "RECEIVED": "단말 수신 완료",
    "Configuration_deviceRegistrationCnt_DESC": "단말기에 에이전트 설치 회수를 설정합니다. (단위 : 개, 기본값: 5, 범위 : 1~5)",
    "AUDIT_DefenceSettingService_updateDate": "갱신시간",
    "LostDate": "분실/도날 신고 일시",
    "AUDIT_HolidaysService_holiday": "휴일",
    "MdmPolicyControlName_safariAllowJavaScript": "자바스크립트 활성화",
    "LANG_APP_BusinessAppStateCheck": "사용자가 설치한 업무앱 현황을 보실 수 있습니다.",
    "LANG_tue": "화",
    "LANG_LOG_StateOS": "단말기 OS 현황",
    "LANG_APP_AgentAppState": "에이전트 설치현황",
    "LANG_POLICY_CONDITION_TITLE_TYPE_LOCATION_SELECT": "위치 선택",
    "LANG_LOC_managementGPS": "GPS관리란? MDM정책이 실행되는 위치 정보를 관리합니다.",
    "Title_Deputy": "차장",
    "NotBefore": "유효기간 시작",
    "LANG_INITPW_UNMATCHING_PASSWORD": "입력하신 비밀번호가 일치하지 않습니다.",
    "LANG_oct2": "10월",
    "MdmPolicyControlName_AllowAutoUpdate": "자동업데이트 허용.",
    "MdmPolicyControlName_FirewallWhitelist": "방화벽 화이트리스트",
    "AUDIT_ThirdPartyCompanyService_createDate": "생성시간",
    "LANG_APP_LastestVersion": "최신버전",
    "LANG_OsVersion": "OS 버전",
    "LANG_LOG_LostManagementDetail": "단말의 도난/분실 현황을 조회합니다.",
    "LANG_SETTING_NoticeManagementShort": "공지관리",
    "Configuration_reConnectDeviceMaximum": "에이전트 재설치 제한 횟수",
    "AUDIT_UserService_androidDownLoadUrl": "Android Download URL",
    "AUDIT_UserDeviceService_lock": "Lock여부",
    "MESSAGE_ALERT_SUCCESS_REQUEST2": "요청이 정상적으로 처리 되었습니다.",
    "Audit_Pkcs12CertificateService": "정책관리>인증서관리",
    "AUDIT_BeaconAreaService_minorSc": "minorSC",
    "AuditLog": "관리자 감사 로그",
    "LANG_PERSONNEL_MemberManagement": "임직원관리",
    "Validation_phoneNumber": "유효하지 않은 전화번호입니다.",
    "MdmPolicyControlName_allowSafari": "Safari 사용 허용",
    "RC_IGNORE": "명령해제",
    "EditApp": "앱 변경",
    "LANG_SystemSettingsDetail": "MDM서비스를 위한 시스템 설정을 합니다.",
    "Configuration_passwordMaxLength_DESC": "관리자/사용자 패스워드 최대 길이를 설정합니다. (단위 : 자리, 기본값 : 16)",
    "APAuth": "AUTH",
    "AUDIT_UserTitleService_createDate": "생성시간",
    "AL_OfficeAppOn": "업무앱 On",
    "AUDIT_ReservedVisitorService_authToken": "인증토큰",
    "Configuration_systemEmail": "시스템 메일주소",
    "LANG_DEVICE_RemoteCommand": "단말 원격 명령",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT": "비콘 위치 선택",
    "AUDIT_VersionedAppService_updateDate": "갱신시간",
    "RC_SIREN_ON": "사이렌 (Android)",
    "LANG_Self_Desc_not_device": "등록된 단말이 없습니다. 등록후에 사용하시기 바랍니다.",
    "Configuration_passwordChangePeriod": "관리자 비밀번호 변경주기",
    "Title_000001220": "감독관",
    "Title_000001221": "인턴",
    "Title_000001222": "현장대리인",
    "Status": "상태",
    "LANG_WP_federated_enrollment_init_message": "사용자인증을 수행합니다.",
    "LANG_GPSCondition": "GPS 기반 위치조건",
    "ManageGPSLocation": "위치 목록 관리",
    "Configuration_maxSessionCnt": "최대 로그인 가능한 세션 수",
    "LANG_Title_Group": "조직정보",
    "ALLOW_LOCATION_MANDATORY": "강제",
    "ManagementName": "사용자명",
    "LANG_TOP_PolicyManagement": "정책관리",
    "IsNewVersion": "최신여부",
    "jqGrid_view": "상세보기",
    "MdmPolicyControlName_requireAlphanumeric": "알파벳 숫자 값 필요",
    "MdmPolicyControlName_SendIntranetTraffictoInternetExplorer": "인터넷 익스플로러에서 인트라넷 트래픽을 전송할수 있게 허용.",
    "Title_000001217": "부위원장",
    "Title_000001218": "간사",
    "Title_000001219": "노조위원장",
    "VirusResult": "검사 결과",
    "LANG_DELETE_ADMIN_NOT_DELETE": "삭제 관리 계정은 변경 및 삭제가 불가합니다.",
    "MdmPolicyControlName_getCmdsOnConnected": "재연결시 명령전송",
    "Title_000001210": "총무",
    "AUDIT_ReservedVisitorService_companyName": "방문자회사",
    "Title_000001212": "수석연구원",
    "LANG_EntryPolicyTarget": "출입정책 적용 대상",
    "Title_000001211": "TF팀원",
    "Title_000001214": "책임연구원",
    "AL_policyApplyFail": "정책 적용 실패",
    "Title_000001213": "보조연구원",
    "Title_000001216": "연구원",
    "Title_000001215": "선임연구원",
    "AddCompany": "소속사 추가",
    "LANG_LOC_createDate": "등록일시",
    "LANG_POLICY_HolidayManagementDetail": "공휴일에 실행되는 MDM정책을 위하여 공휴일을 관리합니다.",
    "LANG_DEPT_company": "소속사",
    "MdmPolicyControlName_allowActivityContinuation": "활성화된 장치구성 사용 여부",
    "Configuration_clientTimeoutSec": "단말 응답 시간 제한(초)",
    "alertTitle__info": "알림",
    "LANG_POLICY_conditionDetail": "선택된 정책에 적용되어 있는 정책조건을 확인합니다.",
    "LANG_AppDownloadList": "앱 다운로드 목록",
    "Title_000001208": "TF팀전담",
    "LANG_execCommand": "실행명령",
    "Title_000001209": "TF팀지원",
    "AUDIT_NoticeTargetService_targetId": "대상아이디",
    "LANG_Self_Device_find_device": "디바이스 찾기",
    "Title_000001206": "ODA T/F팀장",
    "Title_000001207": "TF팀간사",
    "LANG_POLICY_CertificationManagement": "인증서 관리",
    "AUDIT_DefenceSettingService_id": "ID",
    "Title_000001201": "회장",
    "Title_000001200": "T/F팀장",
    "Title_000001205": "스마트워크추진TF팀장",
    "Title_000001204": "사랑나눔회장",
    "deviceInfoSearch": "단말 기본정보 조회",
    "StartDateValidate": "시작일이 종료일보다 큽니다.",
    "Title_000001203": "성과관리팀장",
    "Title_000001202": "신성장T/F팀장",
    "APDesc": "설명",
    "MESSAGE_ALERT_NOT_EXIST_APP": "{0} 앱의 파일이나 URL이 없습니다.",
    "BUTTON_BACKUP": "백업",
    "LANG_modifyNoneApp": "기타앱 수정",
    "LANG_APP_WhiteAppSelection": "화이트앱 지정",
    "LANG_POLICY_APPLICATION_COMPLETE": "정책 적용 완료",
    "ERROR_UserLoginFailed": "사용자가 로그인에 실패했습니다.",
    "MdmPolicyControlName_forceEnbaledGPS": "GPS 사용 강제화",
    "MdmPolicyControlName_blockCallByPolicy": "전화걸기 차단",
    "Configuration_adminAccessIP4_DESC": "허용 접속 IP 4 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "RC_APP_INSTALL": "앱 설치",
    "LANG_ManageAddressMapToLatitudeLongitude": "위도,경도 적용",
    "RC_NOTNOW": "단말수행대기",
    "ERROR_DeviceIsNotActivatedForUse": "단말 유형이 활성화되지 않았습니다. 해당 모델의 단말을 허용하려면 활성화 해야 합니다.",
    "LANG_AccessOutPolicyDesc": "출입 OUT 일때의 정책항목들을 설정합니다.",
    "LANG_BeaconCondition": "비콘 기기 조건",
    "LANG_Consent_Person_info_Consent": "동의",
    "LANG_WindowPhone": "윈도우",
    "AL_SDCardStatus": "SD 카드 상태",
    "LANG_logStatus": "처리상태",
    "LANG_NotRegistered": "미등록",
    "LANG_network_bad": "불량",
    "LANG_APP_installed": "설치됨",
    "AL_ProfileDeleteToabNormal": "단말 프로파일 삭제(비정상).",
    "LANG_network_good": "정상",
    "LANG_UserManagement": "사용자 관리",
    "ACTION_SystemLockedRemoteSecureDataRemoved": "중요정보 삭제에 의한 시스템 잠금",
    "AddDept": "부서 추가",
    "ERROR_UserIpNotAllowed": "허용되지 않은 IP {0} 로 부터 접근하여 차단되었습니다.",
    "AUDIT_UserService_dept": "부서",
    "LANG_Lost": "분실",
    "LANG_BeaconAreaDescription": "위치부가설명",
    "AppFile": "앱 파일",
    "MdmPolicyControlName_usimCardLock": "Usim 카드 잠금 설정",
    "LANG_writer": "등록자",
    "LANG_LastSyncTimes": "마지막 정책 적용일시",
    "Configuration_scepUrl": "SCEP URL",
    "LANG_Visitor_Header_GNB": "방문자 관리",
    "Severity_WARN": "경고",
    "RC_SYNC": "동기화",
    "LANG_REMOTE_LOST_REPORT_MESSAGE": "분실 / 도난 신고 완료.",
    "AUDIT_ReservedVisitorService_company": "업체",
    "LANG_ERROR_UserIdNotUseMessage": "제한된 관리자입니다.",
    "MdmPolicyControlName_blockAppWithAllowList": "실행 앱 정책",
    "WLAN_SCANMODE_LOW": "저빈도",
    "SerialNumber": "시리얼번호",
    "codeName": "코드명",
    "LANG_TitleMain": "MDM 관리 콘솔",
    "AUDIT_VisitorUserService_employeeDeptName": "방문직원 부서이름",
    "Configuration_clientTimeoutSec_ALERT": "{0} : 300~1200 사이입니다.",
    "ACTION_DeviceRooting": "루팅 폰입니다.",
    "Configuration_passwordCombine": "패스워드 조합",
    "LANG_noData": "데이터가 없습니다.",
    "LANG_policyCondition": "정책적용상태",
    "LANG_Unlock": "잠금해제",
    "LANG_Delete": "삭제",
    "LANG_AgentLogs": "단말 감사 로그",
    "AUDIT_PassingStatusService_createDate": "생성시간",
    "RC_SET_PWD": "시스템 잠금 해제",
    "MdmPolicyControlName_AllowCookies": "쿠키허용.",
    "IsRooting": "루팅여부",
    "AUDIT_Pkcs12CertificateService_hash": "hash값",
    "AUDIT_NoticeService_endDate": "종료일자",
    "Configuration_passwordMaxLength": "패스워드 최대 길이",
    "MdmPolicyControlName_allowAppInstallation": "설치 응용 프로그램 허용",
    "LANG_POLICY_COMMENT_DeploymentPolicy3": "하시면 적용이 완료됩니다.",
    "LANG_REMOTE_RECEIVE_MESSAGE": "긴급메시지",
    "LANG_google_calendar_url": "https://www.google.com/calendar/feeds/south_korea__ko%40holiday.calendar.google.com/public/basic",
    "MdmPolicyControlName_pushUse": "자체 푸쉬 서버 사용",
    "LANG_ExcelExport_UserDevice": "단말리스트",
    "LANG_POLICY_TRANSFER_FAILED": "정책 전송 실패",
    "AUDIT_ProductDeviceService_osName": "OS 종류",
    "ModifyCompany": "소속사 수정",
    "LANG_ManageAddressMap": "주소체크",
    "AUDIT_VersionedAppService_name": "명칭",
    "RoleAdmin": "관리자",
    "AUDIT_VersionedAppService_createDate": "생성시간",
    "LANG_logMessage": "메세지",
    "TargetDevice": "단말",
    "MdmPolicyControlName_MinDevicePasswordLength": "최소 비밀번호 길이.",
    "LABEL_lastRestoreTime": "최종 복구일시",
    "LANG_REQUEST_IS_NOT_COMPLETED": "미완료된 요청이 있어 명령실행대기 처리 되었습니다.",
    "LANG_POLICY_CONDITION_BEACON_AREA": "비콘출입",
    "AUDIT_VersionedAppService_binaryFilePath": "파일경로",
    "AUDIT_Pkcs12CertificateService_certificate": "인증서여부",
    "AUDIT_NoticeService_startDate": "시작일자",
    "Audit_ControlGPSService" : "\uC815\uCC45\uAD00\uB9AC>\uC815\uCC45\uC790\uC6D0\uAD00\uB9AC>GPS \uAD00\uB9AC",
    "Configuration_passwordMinLength_ALERT": "{0} : 9~16으로 지정하여 주십시오.",
    "AUDIT_UserDeviceService_vendor": "제조사",
    "ProductDeviceStatus": "등록상태",
    "LANG_modifyOfficeApp": "업무앱 수정",
    "BUTTON_Cancel": "취소",
    "Configuration_licenseCode_DESC": "MDM 라이선스 정보를 설정합니다.",
    "LANG_INITPW_CHANGE_INFORMATION_MESSAGE": "● 비밀번호 변경주기에 따라 비밀번호 변경이 필요합니다.",
    "LANG_APP_Latestversion": "최신",
    "LANG_BeaconAreaName": "위치명",

    // 4.5.1 추가 입력
    "LANG_RealTime_Audit_Log" : "실시간 감사 로그",
    "LANG_LocationPolicy_Status" : "출입정책 In,Out 현황",
    "Audit_PolicyManagerService" : "\uC815\uCC45\uAD00\uB9AC>\uC815\uCC45\uC124\uC815",
    "LANG_BUTTON_POLICY" : "정책",
    "LANG_BUTTON_LOG" : "로그",
    "LANG_BUTTON_APP" : "설치앱",
    "LANG_BUTTON_REMOTE" : "원격",
    "LANG_TOTAL" : "총",
    "LANG_SEARCHED" : "건이 검색되었습니다.",
    "LANG_ACCESS" : "출입",
    "LANG_Consent_Person_info_Consent_Date": "동의 날짜",
    "LANG_Consent_Person_info_Not_Consent": "미동의",
    "LANG_Recently_IssueLog": "최근 이슈 로그",
    "LANG_License_Status": "라이센스 현황",
    "LANG_Rooting_Count" : "루팅 수",
    "LANG_Profile_Delete_IOS_Status" : "IOS 프로파일 삭제 현황",
    "LANG_CONTENT" : "내용",
    "LANG_Applies_Target" : "적용 대상",
    "LANG_APP_Info" : "앱 정보",
    "LANG_TargetDevice" : "디바이스",
    "LANG_Attribute_Name" : "속성 이름",
    "LANG_TOP" : "최상위",
    "LANG_UseList" : "할 리스트",
    "LANG_Report_Lost/Stolen_Device" : "단말기 도난/분실 신고",
    "LANG_Report_Lost/Stolen_Device_Sub" : "단말기 분실/도난시 이용하는 서비스 입니다.",
    "LANG_Report_Lost/Stolen_Device_Detail" : "※ 분실 / 도난 시 연락받을 수 있는 전화번호와 단말기 습득자에게 전할수 있는 메시지를 입력하신 후 [도난/분실 신고] 버튼을 누르시기 바랍니다.",
    "LANG_Report_Lost/Stolen" : "도난/분실 신고",
    "LANG_Report_Lost/Stolen_Clear" : "도난/분실 신고 해제",
    "LANG_Lost/Stolen" : "분실 / 도난",

    "LANG_Remote_Control_Or_A_Device" : "단말기 원격제어",
    "LANG_Remote_Control_Or_A_Device_Sub" : "단말기 주요기능을 원격으로 제어할 수 있습니다.",
    "LANG_Remote_Command" : "원격 명령",
    "LANG_Remote_Command_Sub" : "분실된 단말기의 기능제어를 할 수 있습니다. 원하시는 기능을 선택하시고 실행버튼을 누르십시오.",
    "LANG_Command_Execution" : "명령 실행",

    "LANG_Backup_Management" : "백업 관리",
    "LANG_Backup_Management_Sub" : "단말기 주요정보를 서버에 저장 할 수 있습니다.",
    "LANG_Location_Information_Not_Available" : "위치정보에 동의하지 않았기에 위치정보를 사용할 수 없습니다.",
    "IsLastVersion": "최신여부",
    "Message_Alert_Success" : "요청이 처리 되었습니다.",
    "Message_Select_One_Device" : "한개의 단말을 선택해 주세요.",
    "Message_Select_One_Or_More_Devices" : "한개 이상의 단말을 선택해 주세요.",
    "Message_Select_Device" : "단말을 선택해주세요.",
    "Message_Want_Run_it" : "정말 실행 하시겠습니까?",
    "LANG_Remote_Control_Execution" : "원격제어 실행",

    "LANG_Want_BackUp" : "백업 하시겠습니까?",
    "LANG_Want_Restore" : "복구 하시겠습니까?",
    "LANG_Backup/Recovery" : "백업/복구",

    "LANG_PolicyConfig_Sub1" : "※ 정책을 추가 및 수정하신 다음에 저장 후에 하단에 있는",
    "LANG_PolicyConfig_Sub2" : "대상 배포하기를 클릭",
    "LANG_PolicyConfig_Sub3" : "하시면 적용이 완료됩니다.",
    "LANG_Group_deploy" : "그룹 배포하기",
    "LANG_User_deploy" : "유저 배포하기",
    "LANG_Device_deploy" : "디바이스 배포하기",
    "LANG_Select_Policy_Condition" : "정책 조건 선택",
    "LANG_Policy_Type" : "정책 타입",
    "LANG_Policy_AreaType" : "지역 타입",
    "LANG_Add_Del" : "추가 및 삭제",
    "LANG_Around_Address" : "주변 주소",
    "LANG_GPS_Name" : "GPS명",
    "LANG_Basic_Policy" : "기본정책",
    "LANG_Access_Policy" : "출입정책",
    "LANG_BeaconName" : "Beacon명",
    "LANG_Left_Click_Tree" : "좌측 트리를 먼저 클릭해주세요.",
    "LANG_GPS_description" : "GPS 설명",
    "LANG_Beacon" : "비콘",
    "MESSAGE_GPS_ADD_SAVE" : "gps 좌표를 추가 후 저장해주세요.",
    "MESSAGE_GPS_3More_ADD" : "gps 좌표를 3개이상 추가해주세요.",
    "MESSAGE_GPS_ADD_Fail" : "gps 좌표 추가 실패하였습니다, 리셋 후 다시 시도해 주세요.",
    "MESSAGE_Distribution_Ok" : "배포가 완료되었습니다.",
    "MESSAGE_Target_Add_Ok" : "적용대상 추가 완료",
    "MESSAGE_Success_Ok" : "저장 완료",
    "MESSAGE_Success_Fail" : "저장 실패",
    "LANG_Add_Access_Policy" : "출입정책 추가",
    "MESSAGE_Select_Policy_Delete" : "삭제 할 정책을 선택해 주세요.",
    "MESSAGE_Want_Delete" : "정말 삭제 하시겠습니까?",
    "MESSAGE_Select_Policy_First" : "정책을 먼저 선택해주세요.",
    "MESSAGE_Success_Add_Policy" : "저장 추가 성공",
    "MESSAGE_Fail_Add_Policy" : "저장 추가 실패",
    "MESSAGE_Add_OneMore_Group" : "그룹을 1개이상 추가해주세요.",
    "MESSAGE_Add_OneMore_User" : "유저를 1개이상 추가해주세요.",
    "MESSAGE_Add_OneMore_Device" : "디바이스를 1개이상 추가해주세요.",
    "LANG_Noraml2" : "일반",
    "LANG_Office_App" : "오피스앱 ",
    "MESSAGE_PolicyCondition_Add" : "정책 조건 추가 완료",
    "LANG_View_Detail" : "상세 보기",
    "LANG_POLICY_conditionConfig_Add" : "정책 설정 조건 추가",
    "MESSAGE_Select_OneMore_App" : "앱을 하나이상 선택 해야 합니다.",
    "MESSAGE_Select_PolicyCondition" : "정책 조건을 선택해주세요.",
    "MESSAGE_ANY_Default_Not_Delete" : "ANY 기본은 삭제가 불가능합니다.",
    "MESSAGE_Default_Policy_Not_Delete" : "디폴트 정책은 삭제할 수 없습니다.",
    "MESSAGE_Policy_Add_Ok" : "정책 추가 완료",
    "MESSAGE_Policy_Add_Fail" : "정책 추가 실패",
    "LANG_LOG_DeviceStatusByAttribute" : "속성별 단말현황",
    "LANG_Rooting" : "루팅",
    "LANG_Device_Os_Count" : "OS별 단말 수",
    "LANG_LastVersion_Status" : "최신버전 설치 현황",
    "LANG_Connection_Status" : "연결 상태",
    "MESSAGE_SearchDate_Require" : "검색 날짜는 필수 조건 입니다.",
    "MESSAGE_LastDate_Less_StartDate" : "검색 마지막 날짜는 시작 날짜 보다 작을 수 없습니다.",
    "MESSAGE_Search_And_Out" : "날짜 검색 후 출력해 주세요.",
    "MESSAGE_Select_LogType" : "로그타입을 선택해 주세요.",
    "LANG_Target_Notice_Del" : "대상삭제",
    "MESSAGE_Select_Property_LeftTree" : "좌측트리에서 속성을 선택해 주세요.",
    "MESSAGE_Save_Complete" : "저장이 완료되었습니다.",
    "LANG_Activation" : "활성화",
    "LANG_Disabled" : "비활성화",
    "MESSAGE_Select_Only_One" : "1개만 선택해주세요.",
    "LANG_Number" : "번호",
    "MESSAGE_Enter_Company_Name" : "회사 이름을 입력해주세요.",
    "MESSAGE_Duplicate_Company" : "중복된 이름의 회사가 있습니다.",
    "MESSAGE_Added_Complete" : "추가 되었습니다.",
    "MESSAGE_Enter_AttributeType_Name" : "속성타입 이름을 입력해주세요.",
    "MESSAGE_Name_Exist" : "이름이 이미 존재 합니다.",
    "MESSAGE_Select_Company_First" : "회사를 먼저 선택해주세요.",
    "MESSAGE_Enter_Attribute_value" : "속성 값 이름을 입력해주세요.",
    "MESSAGE_AttributeCode_Name_Exist" : "속성 코드 및 이름이 이미 존재합니다.",
    "LANG_Use" : "사용",
    "LANG_Not_Use" : "미사용",
    "MESSAGE_Duplicate_ID" : "중복된 아이디가 존재합니다.",
    "MESSAGE_Select_Administrator" : "관리자를 선택해 주세요.",
    "MESSAGE_Choose_Want_Delete" : "삭제할 대상을 선택해 주세요.",
    "MESSAGE_Password_Check_Again" : "비밀번호가 틀립니다. 다시 확인해주세요.",
    "MESSAGE_Setting_Complete" : "설정이 완료되었습니다.",
    "MESSAGE_SessionValue_lessThan300" : "세션값은 300미만은 사용될 수 없습니다.",
    "MESSAGE_Enter_Allowable_IP" : "허용아이피를 입력하세요.",
    "MESSAGE_Maximum_PasswordLength_LessThan_Minimum_PasswordLength" : "패스워드 최대길이는 패스워드 최소길이보다 작을 수 없습니다.",
    "LANG_Company_List" : "회사 리스트",
    "LANG_Enrollment" : "등록",
    "LANG_App_Install" : "앱설치",
    "LANG_App_Delete" : "앱삭제",
    "MESSAGE_Select_OSType" : "OS 종류를 선택해 주세요.",
    "MESSAGE_Policy_Released" : "정책이 해제 되었습니다.",
    "LANG_Policy_Status" : "정책현황",
    "BUTTON_Excel_Registration" : "엑셀 등록",
    "BUTTON_Sample_download" : "양식 다운",
    "LANG_APP_Not_LatestVersion": "미최신",
    "BUTTON_Excel_File_Registration" : "엑셀 파일 등록",
    "LANG_Result" : "결과",
    "MESSAGE_Select_User_First" : "유저를 먼저 선택해주세요.",
    "MESSAGE_Add_Attribute_First" : "속성을 먼저 추가해주세요.",
    "LANG_Excel_User_Registration" : "엑셀 사용자 등록",
    "MESSAGE_Enter_Password" : "비밀번호를 입력해주세요.",
    "MESSAGE_Enter_ID" : "아이디를 입력해주세요.",
    "MESSAGE_One_Attribute_Required" : "속성은 1개 이상은 필수입니다.",
    "LANG_Period_Search" : "기간 검색",
    "LANG_MDM_ManagerPage" : "MDM 관리자 페이지 입니다.",
    "LANG_Enter_ID_Password" : "아이디와 패스워드를 입력하여 주십시오.",
    "ERROR_Login_Failed" : "로그인에 실패했습니다.",
    "BUTTON_Reset" : "리셋",
    "MESSAGE_Enter_Address" : "주소를 입력해주세요.",
    "MESSAGE_Three_Or_More_Coordinates" : "좌표를 3개이상 찍어주세요.",
    "token_expired_time" : "인증토큰 만료 시간",
    "token_authenticate_success" : "인증 완료",
    "OTP_hisotry_title" : "OTP 인증 로그",
    "DB_Sync_Log" : "인사연동현황",
    "DB_Sync_Log_Desc" : "인사연동 현황을 조회합니다.",
    "end_time" : "종료 시간",
    "insert_dept_s_count" : "부서추가성공",
    "update_dept_s_count" : "부서수정성공",
    "delete_dept_s_count" : "부서삭제성공",
    "insert_dept_f_count" : "부서추가실패",
    "update_dept_f_count" : "부서수정실패",
    "delete_dept_f_count" : "부서삭제실패",
    "insert_user_s_count" : "사용자추가성공",
    "update_user_s_count" : "사용자수정성공",
    "delete_user_s_count" : "사용자삭제성공",
    "insert_user_f_count" : "사용자추가실패",
    "update_user_f_count" : "사용자수정실패",
    "delete_user_f_count" : "사용자삭제실패",
    "LANG_File_Upload" : "파일 업로드",
    "LANG_File_Upload_Confirm": "파일 업로드를 하시겠습니까? ",
    "AL_EmergencyUnlockOK" : "긴급해제로그",
    "LANG_Version_Name" : "버전명",
    "LANG_Package_Name" : "패키지명",
	
	"LANG_VISITOR_VisitorManagement": "방문자 관리",
    "LANG_VISITOR_VisitorManagementDetail": "방문자에 대한 정보를 관리합니다.",
    "LANG_VISITOR_VisitorLog": "방문자 출입 이력",
    "LANG_VISITOR_PhoneNumber": "핸드폰 번호",
    "LANG_VISITOR_Type": "방문자 타입",
    "LANG_VISITOR_Type_Common": "일반 방문자",
    "LANG_VISITOR_Type_Regular": "장기 방문자",
    "LANG_VISITOR_Modify": "정보 수정",
    "LANG_VISITOR_LocationVerification": "위치정보 확인",
    "LANG_VISITOR_LocationVerificationLog": "위치정보 확인 이력",
    "LANG_VISITOR_RequestedDate": "요청 날짜",
    "LANG_VISITOR_ApprovedDate": "승인 날짜",
    "LANG_VISITOR_Location": "위치",
    "LANG_VISITOR_PolicyRelease": "정책 해제",
    "LANG_VISITOR_PolicyReleaseStatus": "정책 해제 상태",
    "LANG_VISITOR_LocationStatus_Approved": "승인",
    "LANG_VISITOR_LocationStatus_Unapproved": "미승인",
    "MESSAGE_VISITOR_LocationStatus_Approved": "정책 해제 승인 처리되었습니다.",
    "MESSAGE_VISITOR_LocationStatus_Unapproved": "정책 해제 미승인 처리되었습니다.",
    "MESSAGE_VISITOR_UpdateSuccess": "정책 해제 미승인 처리되었습니다.",
	"LANG_OfficeApp_Version_Status" : "업무앱 버전 현황",
    "LANG_OfficeApp_Version_Detail" : "단말에 설치된 업무앱 버전을 조회합니다.",
    "LANG_Office_Version" : "업무앱 버전",
    "LANG_MDM_Version" : "MDM 버전",
    "LANG_OfficeApp_List" : "업무앱리스트",
    "LANG_InOut_Status" : "In/Out 현황",
    "LANG_InOut_Detail" : "단말에 적용된 정책의 IN/OUT 현황을 조회합니다.",
    "MESSAGE_CONFIRM_Group_Deploy" : "선택된 그룹에 배포하시겠습니까?",
    "MESSAGE_CONFIRM_User_Deploy" : "선택된 사용자에 배포하시겠습니까?",
    "MESSAGE_CONFIRM_Device_Deploy" : "선택된 디바이스에 배포하시겠습니까?"
};



// WEBPACK FOOTER //
// ./src/app/translate/lang-ko.ts